export default {
    "Dashboard": "Painel de Controle",
    "Products": "Produtos",
    "Order": "Pedido",
    "Stores": "Lojas",
    "Service Ticket": "Bilhete de serviço",
    "Pre-order Inventory": "Inventário Pré-venda",
    "Third Bound Goods": "Bens de Terceiros",
    "Withdrawal List": "Lista de Retirada",
    "My Profile": "Meu Perfil",
    "Import List": "Lista de Importação",
    "My Products": "Meus Produtos",
    "Quotation": "Orçamento",
    "Payment": "Pagamento",
    "Shipment": "Remessa",
    "Abnormal": "Anormal",
    "Completed": "Concluído",
    "On Hold": "Em Espera",
    "Canceled": "Cancelado",
    "All": "Todos",
    "Support": "Apoiar",

    "Announcement": "Anúncio",
    "balance": "Saldo",
    "View Detail": "Ver Detalhes",
    "wallet": "Carteira",
    "commission": "Comissão",
    "withdraw": "Retirar",
    "system notification": "Notificação do sistema",
    "Order Quantity": "Quantidade de Pedidos",
    "Commission": "Comissão",
    "Total commission": "Comissão Total",
    "This month Orders": "Pedidos deste mês",
    "This month Revenue": "Receita deste mês",
    "This month Cost": "Custo deste mês",
    "Statistics": "Estatísticas",
    "Reference": "Referência",
    "Date": "Data",
    "Total Orders": "Total de Pedidos",
    "Cost": "Custo",
    "Show More": "Mostrar Mais",
    "Quick Summary": "Resumo Rápido",
    "orders": "pedidos",
    "Waiting to place order": "Aguardando para fazer um pedido",
    "Waiting for tracking code": "Aguardando código de rastreio",
    "Authorized": "Autorizado",
    "Share by APP": "Compartilhar por APP",
    "Share": "Compartilhar",
    "Scan share to WeChat": "Compartilhar por código QR no WeChat",
    "Share by link": "Compartilhar por link",
    "Share link": "Link de Compartilhamento",
    "Copy Link": "Copiar Link",
    "Clear": "Limpar",
    "Close": "Fechar",
    "Your vendor": "Seu fornecedor",
    "is inviting you to allocate your Orders": "está convidando você para alocar seus Pedidos",
    "Your store name": "Nome da sua loja",
    "Dispatch order method": "Método de envio do pedido",
    "All my unfulfilled / partially fulfilled orders": "Todos os meus pedidos não atendidos / parcialmente atendidos",
    "Cycle time": "Tempo de ciclo",
    "Every 1 day": "A cada 1 dia",
    "You can modify your order dispatch rules at any time in the menu 'My Orders >> Dispatch settings": "Você pode modificar suas regras de envio de pedidos a qualquer momento no menu 'Meus Pedidos >> Configurações de Envio",
    "Remind later": "Lembrar mais tarde",
    "I agree": "Concordo",
    "According to your settings, we found some data for you": "De acordo com suas configurações, encontramos alguns dados para você",
    "Shopify order": "Pedido da Shopify",
    "Dispatch in the Next Cycle": "Enviar no Próximo Ciclo",
    "Dispatch Immediately": "Enviar Imediatamente",
    "Revenue": "Receita",
    "You can modify your store settings at any time in the menu 'My Stores'": "Você pode modificar as configurações da sua loja a qualquer momento no menu 'Minhas Lojas'",
    "Newbie": "Iniciante",
    "Guide": "Guia",
    "Complete personal information": "Completar informações pessoais",
    "Authorize to bind the store": "Autorizar a vinculação da loja",
    "Publish the push product": "Publicar o produto pra enviar",
    "Start pulling orders": "Começar a puxar pedidos",
    "Already": "Já",
    "enter": "entrar",
    "offline": "offline",
    "success": "sucesso",
    "Add vendors success": "Adicionar fornecedores com sucesso",
    "Total Revenue": "Receita Total",
    "Total Cost": "Custo Total",
    "Has been copied to the clipboard": "Foi copiado para a área de transferência",
    "Copy to clipboard failed, please copy manually": "Falha ao copiar para a área de transferência, por favor copie manualmente",

    "Waiting": "Aguardando",
    "Processing": "Processando",
    "Failed": "Falhou",
    "Are you sure you want to push?": "Tem certeza de que deseja enviar?",
    "Do you want to delete this task?": "Deseja excluir esta solicitação?",
    "The update  has started, it will take a while to finish.": "A atualização começou, levará um tempo para terminar.",
    "Do you want to delete the product?": "Deseja excluir o produto?",
    "Do you want to Export the product?": "Deseja Exportar o produto?",
    "Export success": "Exportar com sucesso",
    "Please select the products": "Por favor, selecione os produtos",
    "URL required": "URL obrigatório",
    "Import success": "Importação realizada com sucesso",
    "Please select the tags": "Por favor, selecione as etiquetas",
    "Tags added successfully": "Etiquetas adicionadas com sucesso",
    "You can import and manage your AliExpress / Amazon products here before publishing them to your Shopify store. You can publish a product to different stores and add multiple tags to each products.": "Você pode importar e gerenciar seus produtos do AliExpress / Amazon aqui antes de publicá-los em sua loja Shopify. Você pode publicar um produto em diferentes lojas e adicionar várias etiquetas a cada produto.",
    "Import Aliexpress": "Importar do Aliexpress",
    "Import Product": "Importar Produto",
    "Product Name": "Nome do Produto",
    "All Stores": "Todas as Lojas",
    "Filter": "Filtrar",
    "Push": "Enviar",
    "Export": "Exportar",
    "Delete": "Excluir",
    "Add Tags": "Adicionar Etiquetas",
    "Tag management": "Gestão de Etiquetas",
    "Confirm": "Confirmar",
    "Push Setting": "Configuração de Envio",
    "Upload Progress": "Progresso de Upload",
    "Status": "Situação",
    "Images": "Imagens",
    "Sold Out": "Esgotado",
    "Store Name": "Nome da Loja",
    "Price": "Preço",
    "Supply Unit Price": "Preço Unitário de Fornecimento",
    "Your Price": "Seu Preço",
    "Fail Reason": "Motivo da Falha",
    "Edit": "Editar",
    "Open in Web": "Abrir no Navegador",
    "no product": "nenhum produto",
    "All Action": "Todas as Ações",
    "price check": "verificar preço",
    "add related products": "adicionar produtos relacionados",
    "Open in  website": "Abrir no site",
    "Retail price": "Preço de Varejo",
    "Supplier price": "Preço do Fornecedor",
    "NOT SET": "NÃO DEFINIDO",
    "Shopify store": "Loja Shopify",
    "vendors": "fornecedores",
    "You can only upload 5 pictures": "Você só pode carregar 5 imagens",
    "Price units default to": "Unidades de preço padrão para",
    "Please upload pictures": "Por favor, carregue as imagens",
    "Please enter title": "Por favor, insira o título",
    "Please enter price": "Por favor, insira o preço",
    "Are you sure you want to delete it?": "Tem certeza de que deseja excluir isso?",

    "Order Management": "Gestão de Pedidos",
    "Waiting For Quote": "Aguardando Cotação",
    "Pay All": "Pague Tudo",
    "SKU number/quantity/name": "Número SKU/quantidade/nome",
    "Update Order": "Atualizar Pedido",
    "Export Order": "Exportar Pedido",
    "Import Order": "Importar Pedido",
    "Import Product Image": "Importar Produto Imagem",
    "Order Number": "Número do Pedido",
    "Payment Number": "Número de Pagamento",
    "Today": "Hoje",
    "Create Quotation": "Criar Cotação",
    "Abandon Quotation": "Abandonar Cotação",
    "Bulk Payment": "Pagamento em Massa",
    "Continue Pay": "Continuar Pagamento",
    "Requote": "Re-cotar",
    "Product Images": "Imagens do Produto",
    "Please make an offer": "Por favor, faça uma oferta",
    "Supplier Price": "Preço do Fornecedor",
    "Retail Price": "Preço de Varejo",
    "Action": "Ação",
    "Remove": "Remover",
    "offline order": "pedido offline",
    "Wholesale order": "pedido por atacado",
    "Order No.": "Número do Pedido",
    "Created Date": "Data de Criação",
    "Shipping Address": "Endereço de Envio",
    "Customer": "Cliente",
    "Shipping Method": "Método de Envio",
    "Free Shipping": "Frete Grátis",
    "Shipping Cost": "Custo de Envio",
    "Total": "Total",
    "Pay Total": "Total a Pagar",
    "Quote": "Cotação",
    "Pay": "Pagar",
    "Split Order": "Dividir Pedido",
    "Manually Sync": "Sincronizar Manualmente",
    "After-sales": "Pós-vendas",
    "Cancel Order": "Cancelar Pedido",
    "Sku/Quantity/Name": "SKU/Quantidade/Nome",
    "Unable to be sourced": "Não é possível  ser obtido",
    "Attribute Value": "Valor do Atributo",
    "Payment No.": "Número de Pagamento",
    "Payment Time": "Hora do Pagamento",
    "Amount": "Valor",
    "Countdown": "Contagem Regressiva",
    "Cancel Payment": "Cancelar Pagamento",
    "Repay": "Repagar",
    "Supplier Unit Price": "Preço Unitário do Fornecedor",
    "Removed": "Removido",
    "Shipping Type": "Tipo de Envio",
    "LOGISTICS": "LOGÍSTICA",
    "SELF PICKUP": "RETIRADA",
    "PREPURCHASE": "PRÉ-COMPRA",
    "Order ID": "ID do Pedido",
    "Recover": "Recuperar",
    "RecoverAll": "Recuperar todo",
    "Pay with": "Pagar com",
    "Bonus": "Bônus",
    "There is no alternative method of payment": "Não há outro método de pagamento",
    "Please do not close the page during payment": "Por favor, não feche a página durante o pagamento",
    "Close pay": "Fechar pagamento",
    "Your order has been successfully paid": "Seu pedido foi pago com sucesso",
    "The selected orders are abnormal and payment cannot be continued": "Os pedidos selecionados estão anormais e o pagamento não pode ser continuado",
    "Payment can continue after excluding the following goods": "O pagamento pode continuar após excluir os seguintes produtos",
    "After removing the off shelf goods, the order will be returned to the": "Após remover os produtos fora de estoque, o pedido será devolvido ao",
    "price to be quoted": "preço a ser cotado",
    "Select file": "Selecionar arquivo",
    "Click to download": "Clique para baixar",
    "Order Import Template": "Modelo de Importação de Pedidos",
    "Please fill in the form according to the specification, only xlsx format files are supported": "Por favor, preencha o formulário de acordo com a especificação, apenas arquivos no formato xlsx são suportados",
    "The uploaded file cannot exceed 2M, and only the first 99 data are processed": "O arquivo enviado não pode exceder 2M e apenas os primeiros 99 dados serão processados",
    "submit": "enviar",
    "Created At": "Criado Em",
    "Cancel": "Cancelar",
    "Waiting for quotation": "Aguardando cotação",
    "Supplier Quote": "Cotação do Fornecedor",
    "Payment Not Received": "Pagamento Não Recebido",
    "Pending payment": "Pagamento Pendente",
    "Waiting For Fulfill": "não enviado",
    "Fulfilled": "Cumprido",
    "Logistics sync failed": "Falha na logística",
    "Unable to purchase": "Incapaz de comprar",
    "Products off shelf": "Produtos fora de estoque",
    "Payment unfinished": "Pagamento Pendente",
    "Payment to be completed": "Pagamento a ser concluído",
    "Unshipped": "não enviado",
    "Quit quotation": "Desistir da cotação",
    "Payment failed": "Falha no Pagamento",
    "Vendor Verifying Payment": "Fornecedor Verificando Pagamento",
    "Payment result to be returned": "Resultado do Pagamento a ser Retornado",
    "Remove the product": "Remover o produto",
    "Removed the product successful": "Produto removido com sucesso",
    "Delete Successful": "Exclusão bem-sucedida",
    "Please select an order first": "Por favor, selecione um pedido primeiro",
    "Sure to delete this item?": "Tem certeza de que deseja excluir este item?",
    "Delete Successful!": "Exclusão bem-sucedida!",
    "Please select an order": "Por favor, selecione um pedido",
    "Please choose file": "Por favor, escolha um arquivo",
    "Create Success": "Criado com Sucesso",
    "No goods need to be eliminated": "Não há mercadorias para serem eliminadas",
    "No logistics": "Sem logística",
    "Are you sure to abandon payment for the selected order? After abandoning, the order will disappear from the list, which cannot be restored, please operate with caution": "Tem certeza de que deseja abandonar o pagamento para o pedido selecionado? Depois de abandonar, o pedido desaparecerá da lista, e não poderá ser restaurado, por favor, decida com cuidado",
    "No Purchase": "Sem Compra",
    "Unpaid Order": "Pedido não pago",
    "Payment Initiated but Unpaid": "Pagamento Iniciado mas Não Pago",
    "Payment Made but Not Received": "Pagamento Feito mas Não Recebido",
    "The receiving address has no logistics method set": "O endereço de entrega não possui método logístico definido",
    "The order is below the minimum deliverable weight": "O pedido está abaixo do peso mínimo para entrega",
    "The order is below the minimum deliverable volume": "O pedido está abaixo do volume mínimo para entrega",
    "The order is higher than the maximum deliverable weight": "O pedido está acima do peso máximo para entrega",
    "The order is higher than the maximum deliverable volume": "O pedido está acima do volume máximo para entrega",
    "The following product attributes of this order do not meet the attribute requirements of deliverable products": "Os seguintes atributos de produto deste pedido não atendem aos requisitos de atributos de produtos entregáveis",
    "The total weight of the goods in this order does not meet the deliverable requirements": "O peso total dos produtos deste pedido não atende aos requisitos de entrega",
    "Weight": "Peso",
    "Quantity": "Quantidade",
    "Total weight": "Peso Total",
    "Attribute": "Atributo",
    "I Know": "Eu Entendo",
    "Card Number": "Número do Cartão",
    "Expiration": "Validade",
    "Payment amount": "Valor do Pagamento",
    "Payment instructions": "Instruções de Pagamento",
    "Other details": "Outros Detalhes",
    "Payment account": "Conta de Pagamento",
    "Payment voucher": "Comprovante de Pagamento",
    "Add Tracking": "Adicionar Rastreamento",
    "Track number": "Número de Rastreio",
    "Please input the tracking number": "Por favor, insira o número de Rastreio",
    "Track company": "Empresa de Rastreamento",
    "Please select logistics company": "Por favor, selecione a empresa de logística",
    "Your request has been sent": "Sua solicitação foi enviada",

    "My Stores": "Minhas Lojas",
    "Add a new store": "Adicionar uma nova loja",
    "Creation date": "Data de Criação",
    "Auth date": "Data de Autorização",
    "Remove entrusted vendor": "Remover fornecedor confiável",
    "Reauthorize": "Reautorizar",
    "Coming Soon": "Em Breve",
    "vendor is authorizing the store on BCNDropshipping App, please be noted.": "o fornecedor está autorizando a loja no aplicativo BCNDropshipping, por favor, esteja ciente.",
    "If you do not check the relevant permissions, it will affect the use of related functions, please operate with caution": "Se você não verificar as permissões relevantes, isso afetará o uso de funções relacionadas, por favor, escolha com cuidado",
    "Connect": "Conectar",
    "Are you sure you want to cancel the hosting store": "Tem certeza de que deseja cancelar a hospedagem da loja",
    "after you close the hosting, the supplier will not be able to actively quote your order!": "após fechar a hospedagem, o fornecedor não poderá cotar ativamente o seu pedido!",
    "Sure": "Certo",
    "You have successfully hosted the store": "Você hospedou a loja com sucesso",
    "After the successful hosting, your supplier will take the initiative to quote for your pending orders!": "Após a hospedagem bem-sucedida, seu fornecedor irá cotar seus pedidos pendentes!",
    "Choose a vendor": "Escolha um fornecedor",
    "Select": "Selecionar",
    "No Data": "Sem Dados",
    "Save": "Salvar",
    "Add a new vendor": "Adicionar um novo fornecedor",
    "Customer name required": "Nome do Cliente necessário",
    "customers successfully added": "clientes adicionados com sucesso",
    "Are you sure you want to remove entrusted vendor?": "Tem certeza de que deseja remover o fornecedor confiável?",

    "After-sales Ticket": "Bilhete de Pós-venda",
    "Ticket Type": "Tipo de Bilhete",
    "Customer Name": "Nome do Cliente",
    "Approval": "Aprovação",
    "Transaction Type": "Tipo de Transação",
    "Question Type": "Tipo de Questão",
    "Problem Description": "Descrição do Problema",
    "Refund": "Reembolso",
    "Replacement": "Substituição",
    "modify the related information for customer": "modificar as informações relacionadas para o cliente",
    "cancel order": "cancelar pedido",
    "No tracking information": "Sem informações de rastreio",
    "Tracking information not update too long time": "Informações de rastreio não atualizadas por muito tempo",
    "Item damage": "Item danificado",
    "Item missing": "Item faltando",
    "Send wrong product": "Produto enviado errado",
    "Send wrong address": "Endereço enviado errado",
    "On hold order": "Pedido em espera",
    "optional": "opcional",
    "Order Information": "Informações do Pedido",
    "Third party order number": "Número do Pedido de Terceiros",
    "Creation time": "Data de Criação",
    "On Hold Order": "Pedido em Espera",
    "Resend Item": "Reenviar Item",
    "Refund Item": "Reembolsar Item",
    "agree": "concordar",
    "Ticket No.": "Nº do Bilhete",
    "please enter": "por favor, insira",
    "Approval Status": "Status de Aprovação",
    "Await Review": "Aguardando Revisão",
    "Reject": "Rejeitar",
    "Pass": "Passar",
    "Missing Item": "Item Faltando",
    "Wrong Product": "Produto Errado",
    "Modify the related information for customer": "Modificar as informações relacionadas ao cliente",
    "Change color/size": "Mudar cor/tamanho",
    "Change Product": "Mudar Produto",
    "Payment Issues": "Problemas de Pagamento",

    "Pre-order stock order": "Pré-encomendar pedido de estoque",
    "pleaseCusName": "Por favor, Nome do Cliente",
    "Withdrawal list": "Lista de Retirada",
    "Withdrawal method": "Método de Retirada",
    "CreateDate": "Data de Criação",
    "startDate": "Data de Início",
    "endDate": "Data de Término",
    "accountPayee": "Beneficiário da Conta",
    "customersName": "Nome do Cliente",
    "Warning Tips": "Dicas de Aviso",
    "Withdrawal Amount": "Valor de Retirada",
    "reject": "rejeitar",
    "Pending": "Pendente",
    "Approved": "Aprovado",
    "GENERAL INFORMATION": "INFORMAÇÕES GERAIS",
    "CONTACT": "CONTATO",
    "Change": "Alterar",
    "ADD": "ADICIONAR",
    "SOCIAL": "SOCIAL",
    "Notification Settings": "Configurações de Notificação",
    "I want to receive notfications by": "Quero receber notificações por",
    "Mobile phone": "Telefone Celular",
    "Allow system notifhcations": "Permitir notificações do sistema",
    "Allow Customer Services from": "Permitir Serviços ao Cliente de",
    "Allow Dropshipping News": "Permitir Notícias de Dropshipping",
    "Reset All": "Redefinir Todos",
    "Save Changes": "Salvar Mudanças",
    "try again in": "tente novamente em",
    "seconds": "segundos",
    "Discard": "Descartar",
    "Voucher": "Comprovante",
    "abnormal bill": "conta anormal",
    "View detail": "Ver detalhes",
    "download PDF": "baixar PDF",
    "Petitioner": "Peticionário",
    "Invoice Pay": "Pagamento de Pedido",
    "Refund Order": "Reembolso de Pedido",
    "Bonus Recharge": "Recarga de Bônus",
    "Bonus Deduction": "Dedução de Bônus",
    "unpaid": "Pendente",
    "paid": "Pago",
    "refund": "Reembolsado",
    "canceled": "Cancelado",

    "Login/Register": "Entrar/Registrar",
    "Logout": "Sair",
    "Powered by COMEXBCN-BCN DROPSHIPPING": "Desenvolvido por COMEXBCN-BCN DROPSHIPPING",
    "Home": "Lar",
    "PRIVACY POLICY": "POLÍTICA DE PRIVACIDADE",
    "SHIPPING POLICY": "POLÍTICA DE ENVIO",
    "TERMS AND CONDITIONS OF USE": "TERMOS E CONDIÇÕES DE USO",
    "RETURN AND REFUND POLICY": "POLÍTICA DE DEVOLUÇÃO E REEMBOLSO",
    "CONTACT US": "CONTATE-NOS",
    "Category Name": "Nome da categoria",
    "More": "Mais",
    "Product category name": "Nome da categoria do produto",
    "Waiting for the payment result to be returned.": "Aguardando retorno do resultado do pagamento.",
    "You may need to wait a little while": "Precisará aguardar um pouco ",
    "Payment successful": "Pagamento bem sucedido",
    "You have successfully completed your order": "Você concluiu seu pedido com sucesso",
    "View order": "Ver pedido",
    "Sorry, we can't complete the payment.": "Desculpe, não podemos concluir o pagamento.",
    "Add New Address": "Adicionar novo endereço",
    "Product Details": "Detalhes do produto",
    "Please check the purchase produc": "Por favor verifique o produto comprado",
    "out of stock": "fora de estoque",
    "Inventory": "Inventário",
    "Subtotal": "Subtotal",
    "Freight": "Frete",
    "Credits": "Créditos",
    "Combination payment": "Pagamento combinado",
    "Please enter the balance to be used": "Por favor insira o saldo a ser utilizado",
    "Rules: The input amount should be less than the order amount, and only two decimal places": "Regras: O valor de entrada deve ser menor que o valor do pedido e apenas duas casas decimais",
    "Payment method": "Método de pagamento",
    "Amount due (including freight)": "Valor devido (incluindo frete)",
    "Submit orders": "Enviar pedidos",
    "Please select payment method": "Selecione a forma de pagamento",
    "First Name": "Primeiro nome",
    "Please enter the first name": "Por favor insira o primeiro nome",
    "Last Name": "Sobrenome",
    "Please enter the last name": "Por favor insira o sobrenome",
    "Please enter the address": "Por favor insira o endereço",
    "Please enter the country": "Por favor insira o país",
    "Please enter the province": "Por favor insira a província",
    "Please enter the city": "Por favor insira a cidade",
    "Please enter the phone": "Por favor insira o telefone",
    "Please enter the postcode": "Por favor insira o código postal",
    "Set as default shipping address": "Definir como endereço de envio padrão",
    "Reset": "Reiniciar",
    "Search Product": "Pesquisar produto",
    "History": "História",
    "Publish": "Publicar",
    "No Account?": "Sem conta?",
    "Sign up here": "Inscreva-se aqui",
    "Sign in": "Entrar",
    "Forgot your password?": "Esqueceu sua senha?",
    "or Sign in with": "ou faça login com",
    "Already have an account?": "Já tem uma conta?",
    "Products Market": "Mercado de Produtos",
    "Unit Price": "Preço unitário",
    "GO": "IR",
    "Qty Available": "Quantidade disponível",
    "First Available": "Disponível pela primeira vez",
    "Last 7 days": "Últimos 7 dias",
    "Last 14 days": "Últimos 14 dias",
    "Last 30 days": "Últimos 30 dias",
    "Sort by": "Ordenar por",
    "There are no products in this category": "Não há produtos nesta categoria",
    "Please enter your shopify store name to connect the dashboard page": "Insira o nome da sua loja no Shopify para conectar a página do painel",
    "Stock Qty": "Quantidade de estoque",
    "VAT information": "Informações sobre IVA",
    "you can click": "você pode clicar",
    "for VAT information": "para informações sobre IVA",
    "Shipping": "Envio",
    "Shipping to": "Envio para",
    "Please select": "Por favor selecione",
    "Shipping fee": "Taxa de envio",
    "Quality": "Qualidade",
    "inventory": "inventário",
    "Add to List": "Adicionar à lista",
    "Add to Cart": "Adicionar ao carrinho",
    "Specifications": "Especificações",
    "Download the attachment": "Baixe o anexo",
    "product information": "informações do produto",
    "Product category": "Categoria de produto",
    "product name": "nome do produto",
    "Specification": "Especificação",
    "material": "material",
    "size": "tamanho",
    "weight": "peso",
    "The tax-inclusive price of an item is calculated based on the item price set by the seller and the applicable tax rate. You can contact the seller for more details.": "O preço de um item com impostos incluídos é calculado com base no preço do item definido pelo vendedor e na taxa de imposto aplicável. Você pode entrar em contato com o vendedor para obter mais detalhes.",
    "You have authorized a Shopify store，you could": "Você autorizou uma loja Shopify, você poderia",
    "to view details": "para ver detalhes",
    "authorize to login": "autorizar o login",
    "If it is necessary to process your shopify order or to achieve an automatically update for the shipping information to shopify, you could": "Se for necessário processar seu pedido do Shopify ou obter uma atualização automática das informações de envio para o Shopify, você poderia",
    "connect your Shopify store": "conecte sua loja Shopify",
    "and let us help you": "e deixe-nos ajudá-lo",
    "If you have authorized a Shopify store, after the vendor delivers the items, the shipping information will been synchronized to your Shopify store which you had authorized.": "Se você autorizou uma loja Shopify, após o fornecedor entregar os itens, as informações de envio serão sincronizadas com a sua loja Shopify que você autorizou",
    "If there are some Shopify stores in the order list below that have not been authorized, you can": "Se houver algumas lojas Shopify na lista de pedidos abaixo que não foram autorizadas, você poderá",
    "authorize a new one": "autorizar um novo",
    "If you need to view your recent orders, please click": "Se você precisar ver seus pedidos recentes, clique em",
    "Cancelled": "Cancelado",
    "Purchase Order": "Ordem de compra",
    "Tell us more about your request": "Conte-nos mais sobre sua solicitação",
    "Attach image file": "Anexar arquivo de imagem",
    "Browse": "Navegar",
    "What is your store name?": "Qual é o nome da sua loja?",
    "Customer Support Email": "E-mail de suporte ao cliente",
    "Send your request": "Envie sua solicitação",
    "Getting Started": "Começando",
    "Main Features": "Principais recursos",
    "Please enter Shopify store name": "Insira o nome da loja Shopify",
    "The email must not be empty": "O e-mail não pode estar vazio",
    "Send Success,We will contact you soon.": "Envio bem-sucedido, entraremos em contato em breve",

    'Total Payment': 'pagamento total',
    'Total Merchandise': 'Pagamento Total',
    'SKU Details': 'Mercadoria Total',
    'Commodity Price': 'Detalhes do SKU',
    'Subscribe to our newsletter': 'Confirmar',
    'Promotions, new products and sales. Directly to your inbox.': 'Inscreva-se em nossa newsletter',
    'Your email': 'Promoções, novos produtos e vendas. Diretamente na sua caixa de entrada.',
    'Subscribe': 'Seu e-mail',
    'Company Information': 'Inscrever-se',
    'OUR SOCIAL MEDIA': 'Informações da Empresa',
    'PRIVACY STATEMENT': 'NOSSAS REDES SOCIAIS',
    'Terms and Conditions': 'DECLARAÇÃO DE PRIVACIDADE',
    "Login": "Entrar",
    'Maximum recommended size 200px * 200px, image can be adaptive': 'Tamanho máximo recomendado 200px * 200px, a imagem pode ser adaptativa',
    'add image': 'Adicionar imagem',
    'change': 'Mudar',
    'delete': 'Excluir',
    'Back': 'Voltar',
    'Please contact the supplier to improve the external number of the webmaster': 'Por favor, entre em contato com o fornecedor para melhorar o número externo do webmaster',
    'Black': 'Preto',
    'There are currently no products under this category': 'Atualmente não há produtos nesta categoria',
    'Logo': 'Logotipo',
    'You can find the recent quotationsand check offers': 'Você pode encontrar as cotações recentes e verificar ofertas',
    'Maximum recommended size 200px * 200px, image can be adapted': 'Tamanho máximo recomendado 200px * 200px, a imagem pode ser adaptada',
    'Add image': 'Adicionar imagem',
    'Change image': 'Mudar imagem',
    'Shopify tags': 'Tags ',
    'New Tag': 'Nova Tag',
    'Shopify type': 'Tipo Produto',
    'Loading': 'Carregando',
    'Compare Price': 'Comparar Preço',
    'Cost Price': 'Preço de Custo',
    'Product Cost': 'Custo do Produto',
    'incorrect input': 'Entrada incorreta',
    'Tag name': 'Nome da Tag',
    'Distributor commission withdrawal': 'Retirada de Comissão do Distribuidor',
    'Please enter the commission withdrawal amount': 'Por favor, insira o valor de retirada da comissão',
    'Remark': 'Observação',
    'Please enter content': 'Por favor, insira o conteúdo',
    'application time': 'Tempo de Aplicação',
    'start': 'Início',
    'end': 'Fim',
    'to': 'Para',
    'Selected stores': 'Lojas Selecionadas',
    'Please select the Shopify stores': 'Por favor, selecione as lojas do Shopify',
    'Shopify': 'Shopify',
    'Woocommerce': 'WooCommerce',
    'Lazada': 'Lazada',
    'Shopee': 'Shopee',
    'Change All': 'Alterar Tudo',
    'Multiply Price': 'Multiplicar Preço',
    'Add Price': 'Adicionar Preço',
    'Wayfair': 'Wayfair',
    'Push to Store': 'Enviar para Loja',
    'Add Cost Range': 'Adicionar Intervalo de Custo',
    'Rest of the price ranges': 'Restante dos intervalos de preço',
    'Plus': 'Mais',
    'Multiply': 'Multiplicar',
    'Fixed Price': 'Preço Fixo',
    'You can set a specific cent value for your price or comparison': 'Você pode definir um valor específico de centavos para o seu preço ou preço de comparação.',
    'price.': 'Atribuir Centavos',
    'Assign Cent': 'Atribuir comparação em Centavos',
    'Assign compare at Cent': 'Atribuir comparação em Centavos',
    'According to store currency': 'De acordo com a moeda da loja',
    'Apply for products in Import List': 'Aplicar para produtos na Lista de Importação',
    'Add New Tags': 'Adicionar Novas Tags',
    'Are you sure to delete it??': 'Tem certeza de que deseja excluí-lo??',
    'Please enter the New tag': 'Por favor, insira a Nova tag',
    'Do you want to delete this task? Tips': 'Deseja excluir esta tarefa? Dicas',
    'error': 'erro',
    'The update has started, it will take a while to finish.': 'A atualização foi iniciada, levará um tempo para terminar.',
    'save successfully': 'Salvo com sucesso',
    'Do you want these?': 'Você quer esses?',
    'product(s)?': 'produto(s)?',
    'Delete success': 'Exclusão bem-sucedida',
    'Would you like to export ?': 'Gostaria de exportar ?',
    'Unit Cost': 'Custo Unitário',
    'Import Aliexpress / Amazon product URL here and click': 'Importe o URL do produto Aliexpress / Amazon aqui e clique',
    'Product SKU': 'SKU do produto',
    'Not purchased': 'Não comprado',
    'Cost per unit': 'Custo por unidade',
    'Clear selection': 'Limpar seleção',
    'Total Quantity selected': 'Total de quantidade selecionada',
    'Total Quantity': 'Total de quantidade',
    'You can find the recent quotations and check offers': 'Você pode encontrar as cotações recentes e verificar as ofertas',
    'Waiting for vendors respond': 'Aguardando resposta dos fornecedores',
    'Vendors responding quotations': 'Cotações dos fornecedores respondendo',
    'Archived quotations': 'Cotações arquivadas',
    'Unfulfilled': 'Não atendido',
    'Partially Fulfilled': 'Parcialmente atendido',
    'Refunded': 'Reembolsado',
    'Last 90 days': 'Últimos 90 dias',
    'Last 12 months': 'Últimos 12 meses',
    'Custom': 'Personalizado',
    'Order number (ascending)': 'Número do pedido (crescente)',
    'Order number (descending)': 'Número do pedido (decrescente)',
    'Order number': 'Número do pedido',
    'Date (oldest first)': 'Data (mais antiga primeiro)',
    'Date (newest first)': 'Data (mais recente primeiro)',
    'Partially refunded': 'Parcialmente reembolsado',
    'orders selected': 'pedidos selecionados',
    'orders selected, uncheck': 'pedidos selecionados, desmarcar',
    'orders selected, select all': 'pedidos selecionados, selecionar todos',
    'Request Quotation': 'Solicitar Cotação',
    'Only orders in': 'Apenas pedidos em',
    'Paid': 'Pago',
    'No order selected': 'Nenhum pedido selecionado',
    'Create quotation request': 'Criar solicitação de cotação',
    'can': 'pode',
    'waiting for responding': 'aguardando resposta',
    'Confirmed': 'Confirmado',
    'ID Range': 'Intervalo de ID',
    'Order Includes': 'Pedido Inclui',
    'View offers': 'Ver ofertas',
    'Cancel offers': 'Cancelar ofertas',
    'Check offers': 'Verificar ofertas',
    'View offer detail': 'Visualizar detalhes da oferta',
    'Fulfillment': 'Atendimento',
    'My Store': 'Minha Loja',
    'Allocate all to vendor': 'Alocar tudo para fornecedor',
    'Allocate': 'Alocar',
    'button of the page,you can also allocate items from the same SPU to the same vendor': 'botão da página, você também pode alocar itens do mesmo SPU para o mesmo fornecedor',
    'Items': 'Itens',
    'Details': 'Detalhes',
    'Expected price (US$)': 'Preço esperado (US)',
    'Vendors respond': 'Fornecedores respondem',
    'Purchase Order Reconfirm': 'Reconfirmar Pedido de Compra',
    'Vendor name:': 'Nome do fornecedor:',
    'AilExpress shop：': 'Loja AilExpress:',
    'Invite Vendor': 'Convidar Fornecedor',
    'Invite Link:': 'Link de Convite:',
    'Bonus Detail': 'Detalhes do Bônus',
    'Amount($)': 'Valor ()',
    'Product name': 'Nome do Produto',
    'Enter order number': 'Digite o número do pedido',
    'Product information': 'Informações do Produto',
    'Edit Product': 'Editar Produto',
    'Shopify vendor': 'Fornecedor',
    'What is your Email?': 'Qual é o seu e-mail?',
    'Cancel purchase order': 'Cancelar pedido de compra',
    'Use this button to update if missing orders.The process may take a while to finish.': 'Use este botão para atualizar sua Lista de Pedidos se houver pedidos faltando. O processo pode levar um tempo para ser concluído.',
    'Offered Orders': 'Pedidos Oferecidos',
    'Offered Products': 'Produtos Oferecidos',
    'Offer price': 'Preço da oferta',
    'Hold down the slider and drag to the right': 'Mantenha pressionado o controle deslizante e arraste para a direita',
    'In order to keep you informed of the update of the order, we suggest you verify the email': 'Para mantê-lo informado sobre a atualização do pedido, sugerimos que verifique o e-mail',
    'orders can be process, what do you want to do now?': 'os pedidos podem ser processados, o que você deseja fazer agora?',
    'Need new quotation for my orders': 'Preciso de uma nova cotação para meus pedidos',
    'Over 30000+ vendors waiting for offer you price': 'Mais de 30000 fornecedores esperando para oferecer um preço a você',
    'Allocate my exist vendors': 'Alocar aos meus fornecedores existentes',
    'Just check my orders': 'Apenas verificar meus pedidos',
    'If you already have cooperative vendors, you can allocate orders to them': 'Se você já tem fornecedores cooperativos, pode alocar pedidos para eles.',
    'How to process your orders?': 'Como processar seus pedidos?',
    'Please select at least one order and quote for your order': 'Por favor, selecione pelo menos um pedido e solicite uma cotação para o seu pedido',
    'Confirm this Offer': 'Confirmar esta Oferta',
    'All Products': 'Todos os Produtos',
    'Yes, I want to CANCEL this offer': 'Sim, eu quero CANCELAR esta oferta',
    'Cancel the success': 'Cancelar com sucesso',
    'Volume(cm)': 'Volume (cm)',
    'Total volume(cm)': 'Volume total (cm)',
    'Kaieteur Bank Payment': 'Pagamento do Kaieteur Bank',
    'You have successfully completed your order.': 'Você concluiu com sucesso seu pedido.',
    'Sorry, we can': 'Desculpe, não podemos',
    'Pay again': 'Pagar novamente',
    'Receiving': 'Recebimento',
    'days': 'dias',
    'Shipping days': 'Dias de Envio',
    'Discount': 'Desconto',
    'Exchange': 'Câmbio',
    'The supplier has opened a credit limit for you. When your account balance is insufficient, you can deduct the credit limit': 'O fornecedor abriu um limite de crédito para você. Quando o saldo da sua conta for insuficiente, você pode deduzir o limite de crédito.',
    'Quantity of order': 'Quantidade do pedido',
    'Total amount of goods': 'Valor total dos produtos',
    'Tax Amount': 'Valor do imposto',
    'Discounted price of goods': 'Preço com desconto dos produtos',
    'Total freight amount': 'Valor total do frete',
    'Shop discount': 'Desconto da loja',
    'This document is free of freight': 'Este documento está isento de frete',
    'credit&debit card': 'cartão de crédito e débito',
    'qr payment': 'pagamento por QR code',
    'Your No.': 'Seu Nº.',
    'Create Quote': 'Criar Cotação',
    'Quit Quotation': 'Cancelar Cotação',
    'Bulk payment': 'Pagamento em massa',
    'Cancel payment': 'Cancelar pagamento',
    'Manually synced': 'Sincronizado manualmente',
    'Shop price': 'Preço da loja',
    'customer Name': 'Nome do cliente',
    'Not reviewed': 'Não revisado',
    'pass': 'Aprovar',
    'warehouse': 'armazém',
    'address': 'endereço',
    'Product': 'Produto',
    'Payment time': 'Tempo de pagamento',
    'Inventory lock remaining time': 'Tempo restante de bloqueio do inventário',
    'Order quantity': 'Quantidade do pedido',
    'Shipping address': 'Endereço de envio',
    'Request Fullfill': 'Solicitar atendimento completo',
    'Select Payment Method': 'Selecionar Método de Pagamento',
    'All transactions are secure and encrypted': 'Todas as transações são seguras e criptografadas',
    'Quotation to be submitted': 'Cotação a ser submetida',
    'Quoted': 'Cotando',
    'danger': 'perigo',
    'Delivery Address': 'Endereço de entrega',
    'warning': 'aviso',
    'OK': 'OK',
    'cancel': 'cancelar',
    'Binding succeeded!': 'Binding conseguiu!',
    'There is no warehouse, please go to add!': 'Não há armazém, por favor, vá para adicionar',
    'file cannot over 2MB': 'o ficheiro não pode ultrapassar 2MB',
    'Please select an order firs': 'Por favor, selecione um pedido firs',
    'Successfully': 'Com sucesso',
    'Are you sure to initiate a quotation for the selected order?': 'Você tem certeza de iniciar uma cotação para o pedido selecionado?',
    'Are you sure to abandon the quotation for the selected order? After giving up, it cannot be restored, please operate with caution': 'Você tem certeza de abandonar a cotação para a ordem selecionada? Depois de desistir, não pode ser restaurado, por favor, opere com cautela',
    'Payment has not arrived': 'O pagamento não chegou',
    'Awaiting Fulfillment': 'Aguardando Cumprimento',
    'SortBy': 'Triste',
    'Date Ranges': 'Intervalos de datas',
    'Fulfillment Status': 'Status de cumprimento',
    'Export to': 'Exportar para',
    'Selected': 'Selecionado',
    'Some orders had been fulfilled or refunded': 'Algumas encomendas foram cumpridas ou reembolsadas',
    'Export orders': 'Ordens de exportação',
    'Abnormal reason': 'Razão anormal',
    'Date type': 'Tipo de data',
    'Download tracking information': 'Baixar informações de rastreamento',
    'Your Orders are exporting</strong><br/>Your export will be delivered by email to': 'Seus pedidos estão exportando</strong><br/>Sua exportação será entregue por e-mail para',
    'Depending on how many Orders you’re exporting, this could take some time.': 'Dependendo de quantos pedidos você está exportando, isso pode levar algum tempo.',
    '<strong>Your Orders are exporting</strong><br/>Your export will be delivered by email to: . <br/>Depending on how many Orders you’re exporting, this could take some time.': '<strong>Seus pedidos estão exportando</strong><br/>Sua exportação será entregue por e-mail para: . <br/>Dependendo de quantos pedidos você está exportando, isso pode levar a',
    'Notice': 'Aviso',
    'You have': 'Você tem',
    'purchase order(s) need your reconfirm,': 'ordem de compra (s) precisa de sua reconfirmação,',
    'click here': 'clique aqui',
    'to view details.': 'para ver detalhes.',
    'Vendor shipped': 'Fornecedor enviado',
    'unfulfilled / partially fulfilled)': 'não cumprido / parcialmente cumprido)',
    'But': 'Mas',
    'You may download these tracking information and fulfilled these orders in your Shopify store manualy.': 'Você pode baixar essas informações de rastreamento e atender a esses pedidos manualmente em sua loja da Shopify.',
    'Download ALL tracking information': 'Baixe TODAS as informações de rastreamento',
    'sync failed': 'sincronização falhou',
    'Reconfirm': 'Reconfirmar',
    'View Details': 'View Details',
    'Change another vendor': 'Mudar de fornecedor',
    'Cancel this order': 'Cancelar esta encomenda',
    'NOT Joined': 'NÃO ADERIDO',
    'Amount Due': 'Montante devido',
    'Not set up': 'Não configurado',
    'Send to vendor': 'Enviar ao fornecedor',
    'Title': 'Título',
    'Desc': 'Desc',
    'Feedback': 'Feedback',
    'Includes': 'Inclui',
    'Shopify orders': 'Pedidos da Shopify',
    'products': 'produtos',
    'invalid': 'inválido',
    'Income': 'Rendimento',
    'Income will only visible to you': 'A renda só será visível para você',
    'Allow vendor to process these orders': 'Permitir que o fornecedor processe esses pedidos',
    'Do you want to cancel this order?': 'Deseja cancelar esta encomenda?',
    'Don': 'Don',
    'Shopify orders in the': 'Pedidos da Shopify no',
    'Change purchase order to another vendor': 'Alterar ordem de compra para outro fornecedor',
    'Current vendor:': 'Fornecedor actual:',
    'Change to new vendor': 'Mudar para um novo fornecedor',
    'All my vendors': 'Todos os meus fornecedores',
    'Also allocate the products in this purchase order to the new supplier': 'Também alocar os produtos nesta ordem de compra para o novo fornecedor',
    'Order created': 'Ordem criada',
    'Order paid': 'Ordem paga',
    'Login to your': 'Faça login no seu',
    'Order confirmed': 'Pedido confirmado',
    'Your request is been submitted, please wait one moment.': 'Seu pedido foi enviado, por favor aguarde um momento.',
    'The update process has started, it will take a while to finish.': 'O processo de atualização foi iniciado, levará um tempo para terminar.',
    'purchase orders': 'ordens de compra',
    'NEED to finish payment': 'NECESSIDADE de terminar o pagamento',
    'Waiting for allocated': 'Espera por alocado',
    'Waiting for sourcing': 'À espera de abastecimento',
    'Orders processing': 'Processamento de pedidos',
    'Abnormal order': 'Ordem anormal',
    'Quote for Orders': 'Cotação para encomendas',
    'Quote for Product': 'Cotação para o produto',
    'Recent Quotations': 'Citações recentes',
    'orders matching your search': 'ordens que correspondem à sua pesquisa',
    'Email': 'E-mail',
    'Get captcha': 'Obter captcha',
    'Please fill in the correct Email address': 'Por favor, preencha o endereço de e-mail correto',
    'User Email modified successfully': 'User Email modificado com sucesso',
    'Show cancelled orders': 'Mostrar pedidos cancelados',
    'Show all valid orders': 'Mostrar todas as encomendas válidas',
    'unfulfilled / partially fulfilled': 'não cumprido / parcialmente cumprido',
    'Download NOT FULFILLED tracking information': 'Informações de rastreamento NOT FULFILLED',
    'Invite vendor to process': 'Convidar o fornecedor para processar',
    'More Action': 'Mais Ação',
    'Selected saved! Now you can Check the purchase orders': 'Selecionado salvo! Agora você pode verificar as ordens de compra',
    'After your confirmation for the payment, we will notify the vendor by email. You can also proactively notify the vendor to speed the delivery up': 'Após a confirmação do pagamento, notificaremos o fornecedor por e-mail. Você também pode notificar proativamente o fornecedor para acelerar a entrega',
    'Have you finished the payment?': 'Você terminou o pagamento?',
    'Confirm the payment': 'Confirmar o pagamento',
    'The reason must be entered': 'O motivo deve ser digitado',
    'In this tab, we will only filter your': 'Nesta guia, vamos filtrar apenas o seu',
    'Orders which you can allocate to your vendor to process.': 'Pedidos que você pode alocar ao seu fornecedor para processar.',
    'Shop name': 'Nome da loja',
    'Partially fulfilled': 'Parcialmente cumprido',
    'purchased items are delivered': 'os itens comprados são entregues',
    'Select a vendor': 'Selecionar um fornecedor',
    'Product has been allocated': 'O produto foi atribuído',
    'Vendor name / contact / shop name etc.': 'Nome do fornecedor / contato / nome da loja etc.',
    'Here are some other products seems can been allocated to the vendor too, do you want to do it now?': 'Aqui estão alguns outros produtos parece que pode ser atribuído ao fornecedor também, você quer fazê-lo agora?',
    'Selected products': 'Produtos selecionados',
    'Allocate NOW': 'Alocar AGORA',
    'No thanks': 'Não obrigado',
    'Please select at least one order': 'Selecione pelo menos um pedido',
    'Create quotation request?': 'Criar pedido de orçamento?',
    'Order ID From:': 'ID da encomenda de:',
    'Order ID To:': 'ID de encomenda para:',
    'You': 'Você',
    'orders to': 'ordens para',
    'responded': 'respondeu',
    'You can choose the payment method you can accept, we will submit your': 'Você pode escolher o método de pagamento que você pode aceitar,',
    'orders and options to your vendors': 'ordens e opções para seus fornecedores',
    'Warm tips': 'Dicas quentes',
    'orders NOW': 'ordens agora',
    'Place': 'Lugar',
    'You have set the following products to be allocated to the vendors': 'Você definiu os seguintes produtos a serem alocados aos fornecedores',
    'only once. Therefore, the following items will need to be': 'apenas uma vez. Portanto, os seguintes itens precisarão ser',
    're-allocated after the orders are generated again.': 're-alocado depois que as ordens são geradas novamente.',
    'By AliExpress VIP link': 'Por Aliexpress VIP link',
    'Please enter the single number range': 'Por favor, insira o intervalo de número único',
    'The starting order number must be less than the ending order number': 'O número de ordem inicial deve ser menor que o número de ordem final',
    'Product title': 'Título do produto',
    'Expected price': 'Preço esperado',
    'Reply price': 'Preço de resposta',
    'Reply link': 'Link de resposta',
    'published': 'publicado',
    'Yesterday': 'Ontem',
    'My support': 'Meu apoio',
    'You have successfully hosted the': 'Você hospedou com sucesso o',
    'Failure reason': 'Razão de falha',
    'Store products': 'Armazenar produtos',
    'SPU': 'SPU',
    'Store': 'Loja',
    'Query': 'Consulta',
    'Please enter': 'Por favor, insira',
    'State': 'Estatal',
    'Description:': 'Descrição:',
    'Add Vendor': 'Adicionar fornecedor',
    'Edit Vendor': 'Edit Vendor',
    'Destination Country:': 'País de destino:',
    'My sourcing products': 'Meus produtos de abastecimento',
    'Vendor information': 'Informações do fornecedor',
    'Vendor Contact': 'Vendor Contact',
    'Bonus Balance（': 'Saldo de bônus',
    'Sales statistics': 'Estatísticas de vendas',
    'Please enter description': 'Por favor, insira a descrição',
    'Please enter IOSS ID': 'Por favor insira IOSS ID',
    'Please select destination country': 'Selecione o país de destino',
    'Please select at least 1 destination country.': 'Selecione pelo menos um país de destino.',
    'Please enter an IOSS ID with 12 alphanumeric characters.': 'Por favor, insira um IOSS ID com 12 caracteres alfanuméricos.',
    'After saving, your IOSS will be updated to the corresponding order. Are you sure to save?': 'Depois de gravar, o seu IOSS será actualizado para a ordem correspondente. Tem a certeza que irá gravar?',

    'Settings': 'Configurações',
    'According to the new European VAT e-commerce rules, declaration without lOSS will result in a delay in customs clearance and the recipient will be required to pay VAT, as the parcel will be detained when contact of the recipient is incorrect.': 'De acordo com as novas regras europeias de comércio eletrônico de IVA, a declaração sem perda resultará em um atraso no desembaraço aduaneiro e o destinatário será obrigado a pagar o IVA, pois o pacote será retido quando o contato do destinatário estiver incorreto.',
    'IOSS Option': 'IOSS Option',
    'No IOSS': 'Sem IOSS',
    'The amount of the orders (shipping cost included) will be declared and recipients will be required by the customs to pay VAT when parcels arrive in the destination countries of EU': 'O valor dos pedidos (custo de envio incluído) será declarado e os destinatários serão obrigados pela alfândega a pagar IVA quando as encomendas chegarem aos países de destino da UE',
    'Please enter correct and valid IOSS IDs, which should be linked to corresponding destination countries. IOSS ID will not be applied if the destination country is not linked to a correct IOSS ID': 'Insira os IDs IOSS corretos e válidos, que devem estar vinculados aos países de destino correspondentes. O IOSS ID não será aplicado se o país de destino não estiver vinculado a um IOSS ID correto',
    'My IOSS Settings': 'Minhas configurações do IOSS',
    'Declare with my own IOSS': 'Declarar com meu próprio IOSS',
    'Linked Countries': 'Países Ligados',
    'Add IOSSou sure to delete the IO': 'Adicione IOSSou com certeza para excluir o IO',
    'Unlinked Countries:': 'Países não vinculados:',
    'Are you sure to delete the IOSS?': 'Você tem certeza de excluir o IOSS?',
    'More categories': 'Mais categorias',
    'Excluding VAT amount': 'Excluindo o montante do IVA',
    'Vat Amount': 'Valor do IVA',
    'Amount including VAT': 'Montante incluindo o IVA',
    'AliExpress store information': 'Informações da loja Aliexpress',
    'Detailed seller ratings': 'Avaliações detalhadas do vendedor',
    'Recent Products': 'Produtos recentes',
    'Store No.': 'Loja No.',
    'This store has been open since': 'Esta loja está aberta desde',
    'Positive feedback': 'Feedback positivo',
    'Business License': 'Licença comercial',
    'Item as Described': 'Item como descrito',
    'Above': 'Acima',
    'Below': 'Abaixo',
    'Average': 'Média',
    'Shipping Speed': 'Velocidade de envio',
    'Detailed Seller Ratings information is unavailable when there': 'As informações detalhadas das classificações do vendedor não estão disponíveis quando',
    'My Vendors': 'Meus fornecedores',
    'By Vendor Name': 'Por Nome do Fornecedor',
    'By AliExpress Url': 'Por Aliexpress Url',
    'Please enter your vendor': 'Por favor, insira seu fornecedor',
    'Vendor': 'Vendedor',
    'How to get the vendor': 'Como obter o fornecedor',
    'Transaction Flow Line': 'Transaction Flow Line',
    'Recharge Time': 'Tempo de recarga',
    'customer successfully edited': 'cliente editado com sucesso',
    'customer successfully added': 'cliente adicionou com sucesso',
    'Address Management': 'Gerenciamento de endereços',
    'Default Shipping Address': 'Default Shipping Address',
    'First name': 'Primeiro nome',
    'Last name': 'Sobrenome',
    'Phone': 'Telefone',
    'Receipt': 'Recibo',
    'Address': 'Endereço',
    'City': 'Cidade',
    'Postcode': 'Código postal',
    'Province': 'Província',
    'Country': 'Sertão',
    'No address': 'Sem endereço',
    'Do you want to delete?': 'Você quer excluir?',
    'delete successfully': 'excluir com sucesso',
    'My Allocated Products': 'Meus produtos alocados',
    'My Allocated Product': 'Meu produto alocado',
    'Batch Re-allocate': 'Batch Re-alocar',
    'Batch Un-allocate': 'Batch Un-alocar',
    'All my stores': 'Todas as minhas lojas',
    'UN-allocate Success': 'UN-alocar o sucesso',
    'LOGIN': 'LOGIN',
    'Powered by Comexbcn': 'Alimentado por Comexbcn',
    'Privacy policy': 'Política de privacidade',
    'Terms of use': 'Termos de uso',
    'Refund Policy': 'Política de reembolso',
    'FAQs': 'perguntas frequentes',
    'This file format is not supported': 'Este formato de arquivo não é suportado',
    'The file size can not over 2MB': 'O tamanho do arquivo não pode exceder 2MB',
    'Please input your message': 'Por favor, insira sua mensagem',
    'BCNDropshipping - Easy Dropshipping': 'BCNDropshipping - Dropshipping fácil',
    'The question must not be empty': 'A pergunta não deve ser vazia',
    'Shopify store name': 'Nome da loja Shopify',
    'Current Unit Cost': 'Custo unitário atual',
    'Welcome to': 'Bem-vindo ao',
    'Please sign in or register an account to start the chat.': 'Por favor, entre ou registre uma conta para iniciar o chat.',
    'All Items': 'Todos os itens',
    'back': 'dorso',
    'Check All': 'Verificar Todos',
    'Digital Themrmometer Hygrometer Living Ro Digital Themrmometer Hygrometer Living Ro': 'Alta Qualidade Digital Themrmometer Hygrometer Living Ro Digital Themrmometer Hygrometer Living Ro',
    'Bulk Purchase': 'Compra em massa',
    'Do you want to delete selected items?': 'Deseja apagar os itens seleccionados?',
    'Product list page': 'Página da lista de produtos',
    'Bottom': 'Fundo',
    'Top': 'Topo',
    'Hi, welcome to': 'Oi, bem-vindo ao',
    'Welcome to ()! Please sign in or register an account to': 'Bem-vindo ao ()! Por favor, entre ou registre uma conta para',
    'start the chat.': ' iniciar o chat.',
    'Register': 'Cadastro',
    'Recall': 'Recordar',
    'Trade name': 'Nome comercial',
    'Purchase price:': 'Preço de compra:',
    'Start date': 'Data de início',
    'End date': 'Data final',
    'Expected Price': 'Preço esperado',
    'Product link': 'Ligação do produto',
    'Dispatched Items': 'Itens despachados',
    'Valid Invoices': 'Faturas válidas',
    'Valid Amount Due': 'Valor válido devido',
    'Order’s items that you can dispatch to vendors': 'Encomendar itens que você pode enviar para fornecedores',
    'No Picture': 'Sem Imagem',
    'You can modify your order dispatch rules at any time in the menu': 'Você pode modificar as regras de envio do seu pedido a qualquer momento no menu',
    'Dispatch to': 'Enviar para',
    'vendor(s)': 'fornecedor(s)',

    'Please select the vendor': 'Por favor, selecione o fornecedor',
    'Please select the circle period': 'Selecione o período do círculo',
    'Are you sure you want to cancel it?': 'Tem certeza que quer cancelar?',
    'Disputed order': 'Ordem contestada',
    'Awaiting Response': 'Aguardando resposta',
    'Search': 'Busca',
    'Tracking Number': 'Número de rastreamento',
    'Dispute Type': 'Tipo de disputa',
    'Expected Solution': 'Solução Esperada',
    'Create Time': 'Criar Data',
    'Last week': 'Na semana passada',
    'Last month': 'No mês passado',
    'Type': 'Datilografar',
    'Last three months': 'Últimos três meses',
    'The page you are looking for can': 'A página que você está procurando pode',
    'BACK TO HOMEPAGE': 'VOLTAR À PÁGINA INICIAL',
    'Transform Your eCommerce business Into a Powerhouse': 'Transforme seu negócio de comércio eletrônico em uma potência',
    'Importify helps people like you to automate their dropshipping business.': 'A Importify ajuda pessoas como você a automatizar seus negócios de dropshipping.',
    'Product Research': 'Pesquisa de Produto',
    'Are you tired of searching the millions o products on AliExpress for potential winners?': 'Você está cansado de procurar milhões de produtos no Aliexpress por possíveis vencedores?',
    'One-click import products': 'Produtos de importação com um clique',
    'Profit': 'Lucrar',
    'Import products from 30+ top dropshipping vendors, Aliexpress, Alibaba, Amazon, Etsy, Dhgate, Lazada, Shopee, Banggood, Taobao, 1688, Gearbest, Walmart, and many more.': 'Importe produtos de mais de 30 fornecedores dropshipping, Aliexpress, Alibaba, Amazon, Etsy, Dhgate, Lazada, Shopee, Banggood, Taobao, 1688, Gearbest, Walmart e muitos mais.',
    'Pricing Rules': 'Regras de preços',
    'Tired of calculating your target profit margin? Create pricing rules before importing, quickly adjust prices for sales.': 'Cansado de calcular sua margem de lucro alvo? Criar regras de preços antes de importar, ajustar rapidamente os preços para as vendas.',
    'Product Customization': 'Personalização do produto',
    'Use our chrome extension to modify the title, description, images, variants, pricing of the imported products.': 'Use nossa extensão chrome para modificar o título, descrição, imagens, variantes, preços dos produtos importados.',
    'Automate your orders': 'Automatize seus pedidos',
    'The Importify Chrome Extension allows you to fulfill your orders quickly by placing the customer address automatically on the checkout page.': 'O Importify Chrome Extension permite que você atenda seus pedidos rapidamente, colocando o endereço do cliente automaticamente na página de checkout.',
    'Easy vendor Change': 'Easy vendor Change',
    'Replace your product vendor with a new vendor and connect them to your store with a click.': 'Substitua o fornecedor do produto por um novo fornecedor e conecte-o à sua loja com um clique.',
    'Auto Dispatch Collections': 'Auto Dispatch Collections',
    'Auto-dispatch products to your Store collections supported on Shopify, WooCommerce, and Jumpseller.': 'Envie automaticamente produtos para suas coleções da Loja com suporte no Shopify, WooCommerce e Jumpseller.',
    'Split Variants': 'Split Variants',
    'Variants': 'Variantes',
    'Importify gives you the ability to Split variants into Separate products.': 'Importify dá-lhe a capacidade de dividir variantes em produtos separados.',
    'Connect Existing Products': 'Conectar produtos existentes',
    'If you have products that are already on a Shopify, Woocommerce or Jumpseller store, you can connect and manage them in Importify.': 'Se você tiver produtos que já estão em uma loja da Shopify, Woocommerce ou Jumpseller, poderá conectá-los e gerenciá-los no Importify.',
    'Add to Import List': 'Adicionar à lista de importação',
    'View More': 'Ver mais',
    'MORE': 'MAIS',
    'Categories': 'Categorias',
    'Tag': 'Etiqueta',
    'Returnable with in': 'Retornável com em',
    'Find Products': 'Encontrar produtos',
    'My Import List': 'Minha lista de importação',
    'Please select a shipping address': 'Por favor, selecione um endereço de entrega',
    'Please select a shipping method': 'Selecione um método de envio',
    'How to find products? Find products in': 'Como encontrar produtos? Encontre produtos em',
    'Products Market! Dropshipping from Worldwide to Worldwide! :': 'Mercado de produtos! dropshipping de todo o mundo para todo o mundo! :',
    'Email must be filled in': 'O e-mail deve ser preenchido',
    'CAPTCHA must be filled in': 'O CAPTCHA deve ser preenchido',
    'New password must be filled in': 'Nova senha deve ser preenchida',
    'The new password and confirm password must be the same': 'A nova senha e confirmar senha deve ser a mesma',
    'The password must contain letters, and numbers, Minimum 8 characters': 'A senha deve conter letras e números, no mínimo 8 caracteres',
    'Password reset successful': 'Redefinição de senha bem-sucedida',
    'Password must be filled in': 'A senha deve ser preenchida',
    'IN ALL CATEGORIES': 'EM TODAS AS CATEGORIAS',
    'Place Order': 'Colocar ordem',
    'Choose orders': 'Escolher ordens',
    'Manage-Addresses': 'Manage-Addresses',
    'Default Address': 'Endereço padrão',
    'There is no Shipping method to reach the current address': 'Não há método de envio para chegar ao endereço atual',
    'Please select address': 'Por favor, selecione o endereço',
    'Product Price': 'Preço do produto',
    'Choose the products from your Shopify orders to allocated to your vendor': 'Escolha os produtos de seus pedidos da Shopify para alocados ao seu fornecedor',
    'Click the Allocate to vendo button on the bottom of the page.': 'Clique no botão Alocar para Vendo na parte inferior da página.',
    'Tips: You can filter your orders here.': 'Dicas: Você pode filtrar seus pedidos aqui.',
    'Choose or create a new vendor.': 'Escolha ou crie um novo fornecedor.',
    'Click the Allocate button of the page,you can also allocate items from the same SPU to the same vendor': 'Clique no botão Alocar da página, você também pode alocar itens do mesmo SPU para o mesmo fornecedor',
    'Un-allocate selected products': 'Desalocar produtos selecionados',
    'Total vendors': 'Total de fornecedores',
    'Total orders': 'Total de pedidos',
    'Click the': 'Clique no',
    'Allocate to vendor': 'Alocar ao fornecedor',
    'button on the bottom of the page.': 'botão na parte inferior da página.',
    'Total Product': 'Produto total',
    'Previous': 'Anterior',
    'Next': 'Próximo',
    'and Automate': 'e automatizar',
    'your entire dropshipping process': 'todo o seu processo de dropshipping',
    'Place 1 purchase orders': 'Coloque 1 ordens de compra',
    'With just one click, you can easily allocate your stores orders to your vendors and the entire shipping process will be automatically completed.': 'Com apenas um clique, você pode facilmente alocar seus pedidos de lojas para seus fornecedores e todo o processo de envio será automaticamente concluído.',
    'Create a purchase orders to your vendor.': 'Crie ordens de compra para o seu fornecedor.',
    'Choose the Shopify orders you want to sourcing,and click the Make a purchase order button of the page.': 'Escolha os pedidos da Shopify que deseja obter e clique no botão Fazer um pedido de compra da página.',
    'After confirming the operation,The purchase orders will be created successfully.': 'Depois de confirmar a operação, as ordens de compra serão criadas com sucesso.',
    'Share purchase orders URL to your vendor and wait your vendor finish the invoice for you.': 'Compartilhe o URL dos pedidos de compra com seu fornecedor e aguarde o vendedor concluir a fatura para você.',
    'Click the <b>Invite vendor to process</b> button on the bottom of the page.': 'Clique no botão <b>Convidar fornecedor para processar</b> na parte inferior da página.',
    'You can send the purchase orders by Skype, WeChat or share by URL link.': 'Você pode enviar as ordens de compra por Skype, WeChat ou compartilhar por link URL.',
    'I have finished the payment': 'Eu terminei o pagamento',
    '<b>Invite vendor to process</b>': '<b>Convidar fornecedor para processar</b>',
    'Items total': 'Itens totais',
    'You can create a new vendor or select an exist one.': 'Você pode criar um novo fornecedor ou selecionar um existente.',
    'Click the button': 'Clique no botão',
    'on the PO page when you finished your payment.': 'na página de PO quando você terminou seu pagamento.',
    'Through AliExpress proxy payment link': 'Através de Aliexpress link de pagamento proxy',
    'Invite vendor to proess purchase order': 'Convidar fornecedor para proess ordem de compra',
    'After you receive the vendor': 'Depois de receber o fornecedor',
    'Click the button <b>I have finished the payment</b> on the PO page when you finished your payment.': 'Clique no botão <b>Eu terminei o pagamento</b> na página PO quando você terminou seu pagamento.',
    'After vendor shipped, Shopify order will be fulfilled automatically.': 'Após o envio do fornecedor, o pedido da Shopify será processado automaticamente.',
    'After your vendor shipped your order, the shipping information will be sync to your Shopify store automatically.': 'Depois que seu fornecedor enviar seu pedido, as informações de envio serão sincronizadas automaticamente com sua loja da Shopify.',
    'Billing History': 'Histórico de faturamento',
    'Billing': 'Faturamento',
    'Search by bill number or order number': 'Pesquisa por número de conta ou número de ordem',
    'Order Code': 'Código de Ordem',
    'Payment Method': 'Método de pagamento',
    'Request for Quote': 'Pedido de Orçamento',
    'Wait for import': 'Aguardar a importação',
    'Allocate Orders for vendors': 'Alocar pedidos para fornecedores',
    'and Automate <br />your entire dropshipping process': 'e Automatize <br />todo o seu processo de dropshipping',
    'With just one click, you can easily allocate your stores orders to': 'Com apenas um clique, você pode facilmente alocar seus pedidos de lojas para',
    'your vendors and the entire shipping process will be automatically': 'seus fornecedores e todo o processo de envio será automaticamente',
    'completed.': 'completado.',
    'How does it work?': 'Como é que funciona?',
    'Connect to your store': 'Conecte-se à sua loja',
    'Allocate orders to your vendors': 'Alocar pedidos para seus fornecedores',
    'The vendor arranges the delivery': 'O fornecedor organiza a entrega',
    'Automatic fulfillment of your orders by': 'Atendimento automático de seus pedidos por',
    'See what our': 'Veja o que nosso',
    'customers talk about us.': 'os clientes falam sobre nós.',
    'More than 10,000+ customers around the world rely on us!': 'Mais de 10.000+ clientes em todo o mundo confiam em nós!',
    'about': 'sobre',
    'Inquiry': 'Inquérito',
    'Trial calculation of shipping costs': 'Cálculo experimental dos custos de envio',
    'Return able with in': 'Retorne capaz com em',
    'You can import and manage your AliExpress / Amazon products here': 'Você pode importar e gerenciar seus produtos Aliexpress / Amazon aqui',
    'before publishing them to your Shopify store. You can publish a': 'antes de publicá-los em sua loja da Shopify. Você pode',
    'product to different stores and add multiple tags to each products.': 'produto para diferentes lojas e adicionar várias tags para cada produtos.',
    'The Shopify orders still unfulfilled / partially fulfilled even if the vendor had upload tracking information.': 'Os pedidos da Shopify ainda não foram atendidos /parcialmente, mesmo que o fornecedor tivesse informações de rastreamento de upload.',
    'You may download these tracking information and fulfilled these order in your Shopify store manually.': 'Você pode baixar essas informações de rastreamento e atender a esses pedidos em sua loja da Shopify manualmente.',
    'Click': 'Clique',
    'New Type': 'Novo Tipo',
    'need your reconfirm,': 'precisa de sua reconfirmação,',
    'here': 'aqui',
    'Operate': 'Operar',
    'to leam more': 'aprender mais',
    'Current Import Task': 'Tarefa de Importação Atual',
    'Import Task': 'Import Task',
    'Filter by stores': 'Filtrar por lojas',
    'Upload Progress:': 'Upload Progress:',
    'Filter by tags': 'Filtrar por etiquetas',
    'Select an image': 'Selecionar uma imagem',
    'Also publish to Online Store': 'Também publicar na loja online',
    'Loading time to long, check detailed progress': 'Tempo de carregamento por muito tempo, verifique o progresso detalhado',
    'Delete Completed': 'Excluir Completed',
    'Please select the stores': 'Por favor, selecione as lojas',
    'Please enter the tag': 'Por favor insira a tag',
    'Do you want to delete the product(s)?': 'Deseja apagar o produto(s)?',
    'Please enter your store name to connect the dashboard page:': 'Indique o nome da sua loja para ligar a página do painel:',
    'Coming soon': 'Em breve',
    'Track Number': 'Código de rastreio',
    'Shopify order number': 'Número de pedido da Shopify',
    'Shopify store Name': 'Shopify store Nome',
    'Keywords': 'Palavras-chave',
    'results': 'resultados',
    'Assign orders to vender': 'Atribuir ordens para vender',
    'Step One: Select not shipped orders': 'Etapa Um: Selecionar pedidos não enviados',
    'Step Two: Confirm and send these orders to the vendor': 'Passo Dois: Confirmar e enviar esses pedidos para o fornecedor',
    'Choose one vendor': 'Escolher um fornecedor',
    'Please choose one vendor first': 'Por favor, escolha um fornecedor primeiro',
    'Abort to assign': 'Abortar para atribuir',
    'Go to Next': 'Ir para Próximo',
    'Go': 'Ir',
    'Confirm and send these orders to this vendor': 'Confirme e envie estes pedidos para este fornecedor',
    'You can check the invoice by scan this QR Code or visit this URL by your web browser': 'Você pode verificar a fatura digitalizando este código QR ou visitar este URL pelo seu navegador da web',
    'Time Created': 'Tempo Criado',
    'Receiver': 'Recetor',
    'Company': 'Empresa',
    'Save and change the vendor': 'Salvar e alterar o fornecedor',
    'Selected saved': 'Selecionado salvo',
    'Now you can': 'Agora você pode',
    'Send purchase orders to the vendor': 'Enviar ordens de compra para o fornecedor',
    'Check the list again': 'Verifique a lista novamente',
    'A new order successfully created': 'Uma nova ordem criada com sucesso',
    'All Unfulfilled Shopify Orders': 'Todos os pedidos não realizados da Shopify',
    'Quick select of Shopify order items': 'Seleção rápida de itens de pedido da Shopify',
    'Shopify order total': 'Total de pedidos da Shopify',
    'Order Date': 'Data do pedido',
    'Periods of orders:': 'Períodos de encomendas:',
    'shopify orders have been selected and can now be dispatched to your vendor': 'Os pedidos do Shopify foram selecionados e agora podem ser enviados ao seu fornecedor',
    'Dispatch to the vendor': 'Envio para o fornecedor',
    'Please choose an vendor': 'Por favor, escolha um fornecedor',
    'Please choose an item': 'Por favor, escolha um item',
    'All shopify unshipped orders': 'Todos os pedidos não enviados do Shopify',
    'All undelivered shopify orders': 'Todos os pedidos Shopify não entregues',
    'shopify orders have been selected and can now be assigned to your suppliers': 'Os pedidos do Shopify foram selecionados e agora podem ser atribuídos aos seus fornecedores',
    'Payment Record': 'Registro de pagamento',
    'Recharge': 'Recarregar',
    'trade code': 'código comercial',
    'Payment Amount': 'Valor do pagamento',
    'Payment Status': 'Status de pagamento',
    'Payment Date': 'Data de pagamento',
    'If it is necessary to process your shopify order or to achieve an automatically update for the shipping information toshopify, you could': 'Se for necessário processar seu pedido Shopify ou obter uma atualização automática para as informações de envio toshopify, você pode',
    'and let us help you.': 'e deixe-nos ajudá-lo a si.',
    'My to view details.': 'Para ver os detalhes.',
    'The vendor has shipped the product(s), but the shipping information has not been sync to your Shopify store.': 'O fornecedor enviou o produto (s), mas as informações de envio não foram sincronizadas com sua loja da Shopify.',
    'Will not ship': 'Não enviará',
    'Not shipped': 'Não enviado',
    'Logistics fee': 'Taxa de logística',
    'The webmaster has confirmed the  payment': 'O webmaster confirmou o pagamento',
    'The vendor has confirmed the payment': 'O vendedor confirmou o pagamento',
    'The vendor start delivery the orders': 'O fornecedor inicia a entrega das encomendas',
    'Via paypal': 'Via paypal',
    'Through a bank transfer': 'Através de uma transferência bancária',
    'According to the vendor’s setting you can go to': 'De acordo com a configuração do fornecedor, você pode ir para',
    'Aliexpress to buy the item in the vendor’s store': 'Aliexpress para comprar o item na loja do fornecedor',
    'Go to AliExpress NOW': 'Ir para Aliexpress AGORA',
    'Invite vendor to process purchase order': 'Convide o fornecedor para processar o pedido de compra',
    'webmaster has confirmed the payment': 'O webmaster confirmou o pagamento',
    'The webmaster has confirmed the payment': 'O webmaster confirmou o pagamento',
    'Invite vendor': 'Convidar fornecedor',
    'You can download order': 'Você pode baixar ordem',
    'Timeline': 'Cronograma',
    'No more comment': 'Sem mais comentários',
    'You have connected a Shopify store before, for your data security, please': 'Você já conectou uma loja da Shopify antes, para sua segurança de dados,  por favor',
    'log in the Shopify account': 'faça login na conta da Shopify',
    'you connected and view this invoice': 'você se conectou e viu esta fatura',
    'The current invoice page is for preview purposes only, if you are sending to a customer please use the': 'A página da fatura atual é apenas para fins de visualização, se você estiver enviando para um cliente, use o',
    'Invoice Preview': 'Invoice Preview',
    'As shown in Figure 1:': 'Como indicado na figura 1:',
    'As shown in Figure 2:': 'Como indicado na figura 2:',
    'I knew it': 'Eu sabia',
    'Connect your Shopify store': 'Conecte sua loja da Shopify',
    'you can dispatch the Shopify orders to your vendors after the authorization and the shipping information will be automatically synchronized to your Shopify Store.': 'você pode enviar os pedidos da Shopify para seus fornecedores após a autorização e as informações de envio serão automaticamente sincronizadas com sua Shopify Store.',
    'Enter your existing Shopify URL bellow and click “connect”, you will be redirect to Shopify to connect your account to (the authorization will be also completed).': 'Digite seu URL da Shopify existente abaixo e clique em  "conectar", você será redirecionado para a Shopify para conectar sua conta (a autorização também será concluída).',
    'Connect a store and fulfill your Shopify orders, sync logistics information to your Shopify store automatically.': 'Conecte uma loja e atenda seus pedidos da Shopify, sincronize as informações de logística com sua loja da Shopify automaticamente.',
    'Enter your existing Shopify store URL bellow and you': 'Insira o URL da sua loja existente da Shopify abaixo e você',
    'Purchase order base information': 'Informações da base de pedidos de compra',
    'Total number of orders': 'Número total de pedidos',
    'Order items': 'Encomendar itens',
    'Total goods': 'Total de bens',
    'Total purchase amount': 'Valor total da compra',
    'Shipment statistics': 'Estatísticas de remessas',
    'Number of items shipped': 'Número de itens enviados',
    'Amount of goods shipped': 'Quantidade de mercadorias enviadas',
    'Number of items not shipped': 'Número de itens não enviados',
    'Amount of unshipped goods': 'Quantidade de mercadorias não carregadas',
    'Shipment rate': 'Taxa de envio',
    'Amount of non-delivery items': 'Quantidade de itens não entregues',
    'Set the vendor’s SKU': 'Definir o SKU do fornecedor',
    'Set the supply price': 'Definir o preço de fornecimento',
    'Set up payment methods': 'Configurar métodos de pagamento',
    'Payment Methods': 'Métodos de pagamento',
    'Send the invoice to the customer': 'Enviar a fatura ao cliente',
    'The fields to be exported': 'Os campos a serem exportados',
    'the sequence is adjustable by dragging forward and backward': 'a sequência é ajustável arrastando para a frente e para trás',
    'You have not yet selected the fields that can be exported. Please select below.': 'Ainda não seleccionou os campos que podem ser exportados. Seleccione por favor em baixo.',
    'optional fields': 'campos opcionais',
    'unexported fields': 'campos não resolvidos',
    'custom field name': 'nome de campo personalizado',
    'is displayed as': 'é exibido como',
    'BILL To': 'BILL TO',
    'Invoice Number': 'Número da fatura',
    'Invoice Date': 'Data da fatura',
    'Amount Due (US$)': 'Valor devido (US$)',
    'The supplier has shipped, but the logistics information has not been synced to the Shopify shop.': 'O fornecedor enviou, mas as informações de logística não foram sincronizadas com a loja da Shopify.',
    'Reason': 'Razão',
    'The supplier has shipped and the logistics information has been synced to the Shopify shop.': 'O fornecedor enviou e as informações de logística foram sincronizadas com a loja da Shopify.',
    'Mark as shipped': 'Marcar como enviado',
    'to finish the payment': 'para terminar o pagamento',
    'The vender has confirmed the payment.': 'O vendedor confirmou o pagamento.',
    'Remove from order': 'Remover da ordem',
    'You are deleting this product from purchase order. You can still find it': 'Você está excluindo este produto da ordem de compra. Você ainda pode encontrá-lo',
    'in your': 'no seu',
    'Total Amount:': 'Montante total:',
    'Your order has been successfully paid and the order amount is': 'Seu pedido foi pago com sucesso e o valor do pedido é',
    'Close Pay': 'Close Pay',
    'Remove success': 'Remover o sucesso',
    'Track number must be entered': ' O código de rastreio deve ser inserido',
    'Track company must be entered': 'A companhia de trilhas deve ser registrada',
    'Track Url must be entered': 'Track URL deve ser digitado',
    'Please enter Shopify store URL': 'Insira o URL da loja da Shopify',
    'Under authorization, please wait…': 'Sob autorização, por favor aguarde...',
    'Have you finished the payment': 'Você terminou o pagamento',
    'At least one field must be selected': 'Pelo menos um campo deve ser selecionado',
    'The name of the customized header cannot be empty': 'O nome do cabeçalho personalizado não pode estar vazio',
    'Export the order information': 'Exportar as informações do pedido',
    'The size of the uploaded image should not exceed 500kb!': 'O tamanho da imagem carregada não deve exceder 500kb!',
    'Simple, Transparent Pricing': 'Preços simples e transparentes',
    'mportify offers three types of plans; Basic plan, Premium plan, and Gold plan.': 'A mportify oferece três tipos de planos: plano Básico, plano Premium e plano Gold.',
    'Each account starts with a day trial, and your billing cycle begins after the free trial period has ended.': 'Cada conta começa com uma avaliação de um dia e seu ciclo de cobrança começa após o término do período de avaliação gratuita.',
    'Importify Plans<': 'Importar Planos<',
    'Basics': 'Básico',
    'Premium': 'Premium',
    'Gold': 'De ouro',
    'Offers': 'Oferece',
    'Amazon & Aliexpress importer': 'Amazon & Aliexpress importador',
    'Semi-automatic order fulfillment (Supported on Aliexpress, Amazon, Dhgate & Wonify)': 'Semi-automático atendimento de pedidos (Suportado em Aliexpress, Amazon, Dhgate & Wonify)',
    'Product Customisation': 'Produto Personalização',
    'Description text': 'Texto descritivo',
    'VAT rate(Destination only in Germany)': 'Taxa de IVA (Destino apenas na Alemanha)',
    'Shipping options': 'Opções de envio',
    'Fulfilment costs': 'Custos de execução',
    'Fulfillment Costs': 'Custos de atendimento',
    'Shipping time': 'Tempo de envio',
    'Update Product': 'Atualizar Produto',
    'Shipping Time': 'Tempo de envio',
    'After Sales Service': 'Serviço pós-venda',
    'product description': 'descrição do produto',
    'Store price': 'Preço da loja',
    'Delivery: Varies for items shipped from an international location': 'Entrega: Varia para itens enviados de um local internacional',
    'This product has been removed from the shelves': 'Este produto foi removido das prateleiras',
    'Return': 'Retorno',
    'Enter Store name': 'Digite o nome da loja',
    'Enter vendor name': 'Digite o nome do fornecedor',
    'Open in website': 'Abrir no site',
    'Purchase List': 'Lista de compras',
    'Complete your Skype or WhatsApp details to get rewards': 'Complete seus detalhes do Skype ou WhatsApp para obter recompensas',
    'You have completed the Skype or WhatsApp, you can receive a free gift package.': 'Você concluiu o Skype ou WhatsApp, você pode receber um pacote de presente gratuito.',
    'The captcha was sent successfully': 'O captcha foi enviado com sucesso',
    'Order Details': 'Detalhes do pedido',
    'Sub Order NO': 'Sub Order NO',
    'Product Information': 'Informações sobre o produto',
    'Sub Total': 'Sub Total',
    'Grand Total': 'Total geral',
    'Tracking Number:': 'Número de rastreio:',
    'Total Amount': 'Montante total',
    'Products Cost': 'Produtos Custo',
    'Enter SKU': 'Digite SKU',
    'Package': 'Pacote',
    'I agree the': 'Concordo com a',
    'Pay NOW': 'Pagar AGORA',
    'All vendors': 'Todos os fornecedores',
    'Dispatch Status': 'Dispatch Status',
    'You could select multiple vendors': 'Você pode selecionar vários fornecedores',
    'Shipping Cost Included': 'Custo de transporte incluído',
    'Do you want to cancel the order?': 'Deseja cancelar a encomenda?',
    'Order was successfully cancelled': 'Ordem foi cancelada com sucesso',
    'Choose your recharge package': 'Escolha o seu pacote de recarga',
    'Choose your payment method': 'Escolha o seu método de pagamento',
    'Platform Reply': 'Platform Reply',
    'Picture': 'Quadro',
    'Product Title:': 'Título do produto:',
    'Price Range:': 'Faixa de preço:',
    'Base Information': 'Informação básica',
    'Product Links:': 'Ligações do produto:',
    'Product Description:': 'Descrição do produto:',
    'Trade Name': 'Nome comercial',
    'Only matching last': 'Apenas combinando por último',
    'Save Rule': 'Salvar Regra',
    'Please select the Period': 'Por favor selecione o Período',
    'Please select the vendor visibility': 'Selecione a visibilidade do fornecedor',
    'Automatic dispatch orders setting': 'Configuração de ordens de envio automático',
    'Show hidden orders': 'Mostrar ordens ocultas',
    'Choose my all Shopify products': 'Escolha meus todos os produtos da Shopify',
    'shopify orders have been selected and can now be dispatched to your vendors': 'Shopify ordens foram selecionadas e agora pode ser enviado para seus fornecedores',
    'My all Shopify products': 'Meus todos os produtos da Shopify',
    'days unfulfilled orders': 'dias de encomendas não cumpridas',
    'Dispatch rule TEST': 'Regra de envio TEST',
    'THE BRIDGE CONNECTING SUPPLIERS AND YOU, MAKING DROPSHIPPING BUSINESS MORE CONVENIENT': 'A PONTE QUE CONECTA FORNECEDORES E VOCÊ, TORNANDO O NEGÓCIO DROPSHIPPING MAIS CONVENIENTE',
    'Your supplier only needs to register an account to quickly build the system': 'Seu fornecedor só precisa registrar uma conta para construir rapidamente o sistema',
    'One-click hosting of stores, fast synchronization of orders': 'Hospedagem de lojas com um clique, sincronização rápida de pedidos',
    'Automatically synchronize logistics information': 'Sincronize automaticamente as informações de logística',
    'Quick Access': 'Acesso Rápido',
    'Do you have an BCN supplier for you': 'Você tem um fornecedor BCN para você',
    'Already have a supplier': 'Já tem um fornecedor',
    'I don': 'I don',
    'Let your supplier fulfill your order more systematically, copy the link and send it to your supplier, and immediately invite your supplier to settle in,': 'Deixe seu fornecedor cumprir seu pedido mais sistematicamente, copie o link e envie-o ao seu fornecedor e imediatamente convide seu fornecedor para se instalar,',
    '2024-2024BCN All Rights Reserved': '2024-2024BCN Todos os direitos reservados',
    'Waiting for the payment result to be returned': 'À espera que o resultado do pagamento seja devolvido',
    'Please check the purchase products': 'Por favor, verifique os produtos de compra',
    'After the combination payment is enabled, the account balance will be deducted first, and the rest will be paid by other selected methods': 'Depois que o pagamento da combinação estiver ativado, o saldo da conta será deduzido primeiro e o restante será pago por outros métodos selecionados',
    'Please select the goods first!': 'Por favor, selecione as mercadorias primeiro!',
    'Please choose the logistics channel': 'Por favor, escolha o canal de logística',
    'Please try again later ~': 'Tente novamente mais tarde ~',
    'User Name': 'Nome de usuário',
    'Users login': 'Login de usuários',
    'Password': 'Senha',
    'Auth Status': 'Auth Status',
    'All Status': 'Todos os Status',
    'Unauthorized': 'Não autorizado',
    'Delete Task': 'Excluir Task',
    'Sale price': 'Preço de venda',
    'Select the task': 'Selecionar a tarefa',
    'Create a ticket': 'Criar um ticket',
    'Request': 'Pedido',
    'Store name:': 'Nome da loja:',
    'No Message': 'Sem Mensagem',
    'Send': 'Enviar',
    'Please enter a value greater than 0': 'Insira um valor maior que 0',
    'Please enter a value less than the total amount of the order': 'Introduza um valor inferior ao valor total da encomenda',
    'What is your Shopify store name?': 'Qual é o seu nome de loja da Shopify?',
    'Transaction': 'Transacção',
    'normal bill': 'conta normal',
    'Account payee': 'Beneficiário da conta',
    'Payment Code': 'Código de pagamento',
    'Third Party Number': 'Número de Terceiros',
    'The export of time': 'A exportação do tempo',
    'Trade type': 'Tipo comercial',
    'Rewards QTY left': 'Recompensas QTY restante',
    'Trade amount': 'Valor comercial',
    'Payment type': 'Tipo de pagamento',
    'Amount paid/Credit payment': 'Valor pago/pagamento de crédito',
    'Payment order': 'Ordem de pagamento',
    'Refund order': 'Ordem de reembolso',
    'Wallet card': 'Carteira',
    'Manual deduction': 'Dedução manual',
    'Paying': 'Pagamento',
    'Account paid': 'Conta paga',
    'Vender Name': 'Vender Nome',
    'AliExpress Shop Name': 'Aliexpress Shop Nome',
    'Product allocated': 'Produto atribuído',
    'Purchase amount:': 'Montante da compra:',
    'Created at:': 'Criado em:',
    'Sourcing Now': 'Sourcing Now',
    'Latest cooperation at:': 'Última cooperação em:',
    'How to add': 'Como adicionar',
    'Email Security Verification': 'Email Security Verification',
    'For security reason.We need to verify your email address.Please click': 'Por razões de segurança. Precisamos verificar seu endereço de e-mail.Por favor, clique em',
    'Verify': 'Verificar',
    'My Wallet': 'Minha Carteira',
    'My Balance': 'Meu Saldo',
    'brokerage': 'corretagem',
    'Please enter the withdrawal amount': 'Por favor, insira o valor da retirada',
    'tip': 'gorjeta',
    'Your Total Rewards': 'Seu total de recompensas',
    'orders QTY': 'ordens QTY',
    'We Accept': 'Aceitamos',
    'Charging Method': 'Método de carregamento',
    'Pay with Credit Card': 'Pagar com cartão de crédito',
    'Paypal Payment Amount': 'Paypal Valor do pagamento',
    'The amount of each recharge must be more than 100 dollars.': 'O valor de cada recarga deve ser superior a 100 dólares.',
    'Please verify your email address here,': 'Por favor, verifique o seu endereço de e-mail aqui,',
    'Withdraw Cash': 'Sacar dinheiro',
    'I see': 'Vejo',
    'Trade status': 'Status comercial',
    'Enter Verification Code': 'Digite o código de verificação',
    'Verify Email': 'Verificar Email',
    'Bill Number': 'Bill Number',
    'Transfer ID': 'Transfer ID',
    'wallet recharge': 'recarga de carteira',
    'The minimum payment is $100.': 'O pagamento mínimo é de $100.',
    'Powered by': 'Alimentado por',
    'All transactions are secure and encrypted.': 'Todas as transações são seguras e criptografadas.',
    'Account Balance': 'Saldo da conta',
    'Withdrawal amount': 'Valor de retirada',
    'We will charge you 5% fee when withdrawing.': 'We will charge you 5% fee when withdrawing.',
    'Send Verification Code': 'Enviar código de verificação',
    'The verification code will be sent to your email': 'O código de verificação será enviado para o seu e-mail',
    'Please enter your withdrawal amount': 'Por favor, insira o valor do seu levantamento',
    'Please enter your account': 'Por favor, insira sua conta',
    'Please enter your account name': 'Digite o nome da sua conta',
    'Please enter the code': 'Por favor, digite o código',
    'Please enter the recharge amount': 'Por favor, insira o valor da recarga',
    'The minimum payment is $100': 'O pagamento mínimo é de $100',
    'The Code was sent successfully': 'O código foi enviado com sucesso',
    'Our app is now updating the page you are visiting, we will auto refresh this page in 10 seconds.': 'Nosso aplicativo agora está atualizando a página que você está visitando, vamos atualizar automaticamente esta página em 10 segundos.',
    'I got it, please refresh it now': 'Eu tenho isso, por favor atualize-o agora',
    'Estimated start time:': 'Hora de início estimada:',
    'Security Verification': 'Verificação de Segurança',
    'We noticed you haven': 'Notamos que você se refugiou',
    'For security reason.We need to verify your email address.': 'Por motivos de segurança. Precisamos verificar seu endereço de e-mail.',
    'Send To:': 'Enviar para:',
    'Please click': 'Por favor clique',
    'Work order number': 'Número da ordem de serviço',
    'Pending review': 'Revisão pendente',
    'After-sales work order': 'Ordem de trabalho pós-venda',
    'Work order type': 'Tipo de ordem de serviço',
    'order number': 'número de ordem',
    'client': 'cliente',
    'shop': 'loja',
    'creation time': 'tempo de criação',
    'question type': 'tipo de pergunta',
    'afterSales': 'pós-venda',
    'after sales': 'pós-venda',
    '请输入': "Por favor, entre",
    '工单号': 'Número da ordem de serviço',
    '同意': 'Aceitar',
    '已确认': 'Verificada',
    "售后工单": "Ordem de serviço pós-venda",
    '工单类型':  "Tipo de ordem de serviço",
    '客户名称':  "Nome do cliente",
    '审批':  "Aprovação",
    "交易类型": "Tipo de Transação",
    "问题类型": "Tipo de pergunta",
    "问题描述": "Descrição do Problema",
    '退款': "Reembolso",
    '更换': "Substituição",
    "修改客户相关信息": "Modificar as informações relacionadas ao cliente",
    '取消订单': "cancelar pedido",
    '无跟踪信息': "Sem informações de rastreamento",
    '跟踪信息长时间未更新': "As informações de rastreamento não foram atualizadas por muito tempo",
    '物品损坏': "Danos no item",
    '物品丢失': "Item faltando",
    '发送错误产品': "Enviar produto errado",
    '发送错误地址': "Enviar endereço errado",
    '订单暂停': "Em espera",
    '选填': "facultativo",
    "订单信息": "Informações do Pedido",
    "第三方订单编号": "Número do pedido de terceiros",
    "订单编号": "Número do Pedido",
    "店铺": "Lojas",
    "创建时间": "Hora de criação",
    "开泰银行支付": "Pagamento do Banco Kaieteur",
    "供应商已发货，但物流信息未同步到Shopify店铺。": "O fornecedor enviou, mas as informações logísticas não foram sincronizadas com a loja Shopify.",
    "供应商已发货，物流信息已同步到Shopify店铺。": "O fornecedor enviou e as informações logísticas foram sincronizadas com a loja Shopify.",
    "您还没有选择可导出的字段。请在下方选择。": "Você ainda não selecionou os campos que podem ser exportados. Por favor, selecione abaixo.",
    "采购订单基础信息": "Informações básicas do pedido de compra",
    "订单总数": "Número total de pedidos",
    "订单商品项": "Itens do pedido",
    "合计商品总数": "Total de mercadorias",
    "合计采购金额": "Valor total da compra",
    "发货情况统计": "Estatísticas de envio",
    "已发货商品数": "Número de itens enviados",
    "已发货商品额": "Quantidade de mercadorias enviadas",
    "未发货商品数": "Número de itens não enviados",
    "未发货商品额": "Quantidade de mercadorias não enviadas",
    "发货率": "Taxa de envio",
    "不发货商品数": "Número de itens não enviados",
    "不发货商品额": "Quantidade de itens não entregues",
    "当前发票页面仅供预览，如果发送给客户请使用发票编辑页面的'发送发票'功能！": "A página atual da fatura é apenas para visualização, se você estiver enviando para um cliente, por favor, use a função 'Enviar Fatura' na página de edição da fatura.",
    "发票预览": "Visualização da Fatura",
    "如图一所示:页面顶部“发送发票”按钮": "Conforme mostrado na Figura 1: Botão 'Enviar Fatura' no topo da página",
    "如图二所示:页面底部'发送发票'按钮": "Conforme mostrado na Figura 2: Botão 'Enviar Fatura' na parte inferior da página",
    "商品列表页": "Página da lista de produtos",
    "底部": "Parte inferior",
    "顶部": "Topo",
    "请输入单号范围": "Por favor, insira o intervalo de números único",
    "起始单号必须小于结束单号": "O número de pedido inicial deve ser menor que o número de pedido final",
    "确定删除该商品？": "Tem certeza de que deseja excluir este item?",
    "确定": "OK",
    "取消": "Cancelar",
    "已取消": "Cancelado",
    "选取文件": "Selecionar arquivo",
    "点击下载": "Clique para baixar",
    "订单导入模板": "Modelo de Importação de Pedidos",
    "请按规范填写表格，仅支持xlsx格式文件": "Por favor, preencha o formulário de acordo com as especificações, apenas arquivos no formato xlsx são suportados",
    "上传的文件不能超过2M，只处理前99条数据": "O arquivo enviado não pode exceder 2M, e apenas os primeiros 99 dados serão processados",
    '待审核': 'Não revisado',
    '通过': 'Aprovado',
    '拒绝': 'Rejeitado',
    '申诉': 'Apelo',
    "余额":"Saldo",
    "线下":"Offline",
    "提现方式":"Método de Retirada",
    "状态": 'Estado de Aprovação',
    '警告提示': 'Dicas de Aviso',
    '该分类下目前还没有商品': 'Atualmente não há produtos nesta categoria',
    '最大建议尺寸 200px * 200px, 图片可自适应': 'Tamanho máximo recomendado 200px * 200px, a imagem pode ser adaptativa',
    '添加图片': 'Adicionar imagem',
    '更改': 'Alterar',
    '删除': 'Excluir',
    '请联系供应商，完善站长外部编号': 'Por favor, entre em contato com o fornecedor para melhorar o número externo do webmaster',
    '返回': 'Voltar',
    "上传图片大小不能超过 500kb!": "O tamanho da imagem enviada não pode exceder 500kb!",
    "描述文字": "Texto da Descrição",
    "履行费用": "Custos de Cumprimento",
    "发货时效": "Tempo de Envio",

    "Pause": "Pausa",
    "productType": "Tipo de Produto",
    "platform": "Plataforma",
    "Operation": "Operação",
    'All Orders': 'Todos os Pedidos',

    "Yes": "Sim",
    "No": "Não",

    "Damaged Item": "Item danificado",
    "Wrong product": "Produto errado",
    "The client received the order?": "O cliente recebeu o pedido?",
    "Whats happend?": "O que aconteceu?",

    "Send To": "Enviar Para",
    "Split orders": "Dividir pedidos",
    "Reply date": "Data de resposta",

    "We noticed you haven't verified your email address. Go to verify now?": "Notamos que você não verificou seu endereço de e-mail. Ir verificar agora?",
    "Please click 'Send' to get the verification code in your inbox": "Por favor, clique em 'Enviar' para receber o código de verificação na sua caixa de entrada.",
    "You can modify your order dispatch rules at any time in the menu 'My Orders >> Dispatch settings'": "Você pode modificar suas regras de despacho de pedidos a qualquer momento no menu 'Meus Pedidos >> Configurações de Despacho'.",

    "Comexbcn Privacy Statement": "Declaração de privacidade da Comexbcn",
    "How Comexbcn Uses Your Data": "Como a Comexbcn utiliza seus dados",
    "This statement demonstrates how seriously and responsibly we handle user privacy.": "Esta declaração demonstra como tratamos de forma séria e responsável a privacidade do usuário.",
    "It details to the user how our company, COMEXBCN, collects, handles, shares, and processes their data and/or information.": "Detalha ao usuário como nossa empresa COMEXBCN recebe,trata, compartilha e processa seus dados e/ou informações.",
    "This page alerts and informs the user that by choosing our service and app/website,": "Esta página alerta e informa o usuário que, escolhendo nosso serviço e aplicativo/site,",
    "they agree to the use, collection, and processing of dropshipping by Comexbcn,": "ele concorda com sua utilização, com a coleta e processamento de dropshipping da Comexbcn e,",
    "and also that they accept all the “TERMS AND CONDITIONS”.": "também que aceita todos os “TERMOS E CONDIÇÕES”.",
    "Any personal information may be used to help improve our app/website.": "Qualquer informação pessoal poderá servir como forma de ajudar a melhorar nosso aplicativo/site.",
    "Collection and Use of Information": "Coleta e Uso de Informações",
    "If you use our app/website, we may request that you provide personal identification data.": "Se você utiliza nosso aplicativo/site, poderemos solicitar que você forneça dados pessoais para identificação.",
    "This is not limited to the name for full use of our app/website's functions.": "Não estando limitado apenas ao nome para uso total das funções do nosso aplicativo/site.",
    "We also intend to use the data for “marketing activities” and for conducting general research and evaluations.": "Também temos como intenção o uso de dados para “atividades de marketing” e a realização de pesquisas e avaliações gerais.",
    "Values": "Valores",
    "Recognition of the nature of our business and your information": "Reconhecimento da natureza do nosso negócio e suas informações",
    "We perform a legally authorized service to provide services.": "Realizamos um serviço legalmente autorizado para fornecer serviços.",
    "Our commitment is to integrity, transparency, and respect for privacy in all aspects.": "Nosso compromisso com a integridade, transparência e respeito pela privacidade em todos os aspectos.",
    "We will process and use only essential information for our business,": "Iremos processar e utilizar apenas informações essenciais para o nosso negócio,",
    "with personal data belonging solely and exclusively to the user,": "sendo os dados pessoais pertencentes única e exclusivamente ao usuário,",
    "thus respecting its nature and treating it sensitively in every detail.": "respeitando, portanto, sua natureza, tratando de forma sensível em cada detalhe.",
    "Protecting Your Information": "Protegendo suas informações",
    "For any third-party requests requiring your information,": "Para qualquer solicitação de terceiros necessitando suas informações,",
    "our company will only provide it with the user’s consent,": "nossa empresa apenas fornecerá com o consentimento do usuário,",
    "without any sharing with external sources,": "sem qualquer compartilhamento com fontes externas,",
    "unless obligated to comply with applicable laws and regulations,": "a menos que seja citado sendo obrigados a cumprir as leis e regulamentos aplicáveis,",
    "responding to an official subpoena, or any other judicial request,": "respondendo a uma intimação oficial, ou qualquer outra solicitação via judicial,",
    "seeking to protect our user and also our rights.": "buscando proteger nosso usuário e também os nossos direitos.",
    "Usability Rights": "Direitos de Usabilidade",

    "Comexbcn is focused on prevention, striving to avoid errors in its procedures as much as possible. However, if there is any situation where a cancellation and return are desired, our policy for taking appropriate actions is described below.":
        "A Comexbcn trabalha com com foco em prevenção, buscando ao máximo evitar que exista erros em seus procedimentos, porém caso exista qualquer condição no qual o desejo seja o cancelamento do pedido e devolução, a seguir descrevemos nossa política que possa tomar as devidas providências.",
    "Cancellation": "Cancelamento",
    "We accept cancellation requests before the product is shipped or produced. In this case, a full refund will be issued. If the product has already been shipped, it cannot be canceled.": "Recebemos o pedido de cancelamento antes que o produto seja enviado ou produzido. Neste caso o reembolso será em sua totalidade. Se o produto já estiver no envio, não haverá condições de ser cancelado.",
    "Returns": "Devoluções",
    "Respecting the consumer's right to request a return within 10 days after the product's delivery, we accept returns under the condition that the item or items are not in use and are in their original delivery packaging. Our customer service department will request the receipt or proof of purchase to certify the procedure so that the shipment can be made to the correct address.":
        "Respeitando o direito do consumidor em solicitar a devolução no prazo de até 10 dias após a entrega do produto, aceitamos a sua devolução. As condições para que isso ocorra é que o item ou itens não devem estar em uso, e devem estar com a embalagem original da entrega. Nosso departamento de atenção ao cliente irá solicitar o recibo ou comprovante de compra, certificando o procedimento para que a remessa seja realizada para o endereço correto.",
    "Items that are damaged or lost qualify for a full refund, or another item of the same order can be sent under the same conditions, or the corresponding value of the claimed item can be refunded.":
        "Item Danificado ou Extraviado possui reembolso integral, podendo ser enviado outro item do mesmo pedido, nas mesmas condições, ou o valor correspondente ao item reclamado.",
    "Refund Process": "Processo de Reembolso",
    "After receiving the item and performing the check as indicated above, we will notify you of the receipt and the processing time for the refund. A credit of the agreed amount will be issued as agreed between the parties via email, indicating the time frame to complete the process.":
        "Após recebermos o item e realizar a checagem conforme indicado anteriormente, iremos notificar o recebimento e o prazo para o processamento do reembolso, e um crédito do valor conforme acordado entre as partes por e-mail, indicando o tempo hábil para concluir o processo.",
    "For any clarifications, please contact our support at: contato@comexbcn.com with your contact information, indicating the purchased item.":
        "Para qualquer esclarecimento entre em contato com o nosso suporte: contato@comebcn.com , com seus dados para contato, indicando o item comprado.",

    'This application/site is managed by the Comexbcn team. They are responsible for all management, and whenever we use the words "we," "together," and "our," they refer to this team at app.comexbcn.com, including tools, information, and services. Any user who accesses our site and application is conditioned to accept our terms and conditions of use, company policies, and notices mentioned here.':
        'Este aplicativo/site é administrado pela equipe da Comexbcn. Sendo responsáveis por toda gestão, e sempre que utilizamos as palavras “nós”, “juntos” e “nosso” está se referindo a essa equipe app.comexbcn.com, incluindo ferramentas, informações e serviços. Qualquer usuário que acesse nosso site e aplicativo está condicionado à aceitar nossos termos e condições de uso, políticas da empresa e avisos aqui mencionados.',
    'By visiting our application and/or site, purchasing on our platform, you declare that you are engaging in our "Service" and agree to comply with our following terms and conditions of use ("TERMS AND CONDITIONS OF USE"), including additional terms, conditions, and policies referenced here or available via link. These TERMS AND CONDITIONS OF USE apply to users in their entirety on the site or application, without limitation, users who browse, suppliers, customers, merchants, and/or content collaborators.': 'Visitando nosso aplicativo e/ou site, comprando em nossa plataforma você declara que se envolve em nosso “Serviço” e está de acordo em obedecer a nossos seguintes termos e condições de uso (“TERMOS E CONDIÇÕES DE USO”), incluindo termos, condições e políticas adicionais referidas aqui ou disponíveis por link. Tais TERMOS E CONDIÇÕES DE USO se aplicam aos usuários em sua totalidade no site ou aplicativo, sem limitação, usuários que navegam, fornecedores, clientes, comerciantes e/ou colaboradores de conteúdo.',
    'Please read our TERMS AND CONDITIONS OF USE carefully before accessing or using our site/application. By accessing any content on our site/application, you agree to comply with these TERMS AND CONDITIONS OF USE. If you do not agree with our terms and conditions, you may not access our site/application or use any of our services. If these TERMS AND CONDITIONS OF USE are considered an offer, their acceptance is expressly limited to these TERMS AND CONDITIONS.': 'Leia nossos TERMOS E CONDIÇÕES DE USO atentamente antes de acessar ou utilizar nosso site/aplicativo. Acessando qualquer conteúdo do nosso site/aplicativo você concorda em obedecer a esses TERMOS E CONDIÇÕES DE USO. Se não houver concordância com os nossos termos e condições você não poderá acessar nosso site/aplicativo ou utiliza qualquer um dos nossos serviços. Se, portanto, esses TERMOS E CONDIÇÕES DE USO forem por acaso considerados uma oferta, a sua aceitação estará limitada a estes TERMOS E CONDIÇÕES.',
    "Any new feature or tool that is added will also be subject to our terms and conditions. The most recent version of this will always be available on this page. Comexbcn reserves the right to update, delete, or modify any part of the TERMS AND CONDITIONS OF USE by posting updates on our site/application. It is the user's responsibility to check this page to monitor our updates. Your access and use of our site/application constitute your acceptance of these changes.": 'Qualquer novo recurso ou ferramenta que forem adicionados também estarão sujeitos aos nossos termos e condições. Estará sempre disponível a versão mais recente deste nesta página. A Comexbcn se reserva no direito de atualizar, excluir ou modificar qualquer parte dos TERMOS E CONDIÇÕES DO USO publicando sempre em nosso site/aplicativo. É da responsabilidade do usuário verificar essa página para que possa checar nossas atualizações. Seu acesso e utilização do nosso site/aplicativo declara sua aceitação nestas alterações.',
    'SECTION 1 – APPLICATION/SITE TERMS OF USE': 'SEÇÃO 1 – TERMOS DE USO DA APLICAÇÃO/SITE',
    'By agreeing to these TERMS AND CONDITIONS, you may not use the products advertised on the application/site for any illegal or unauthorized purpose, nor may you, under any circumstances, violate any laws in your jurisdiction (including but not limited to copyright laws).': 'Ao concordar com estes TERMOS E CONDIÇÕES, você não pode usar os produtos divulgados no aplicativo/site para propósito ilegal ou não autorizado, nem pode, sobre nenhuma hipótese violar quaisquer leis em sua jurisdição (incluindo, mas não se limitando às leis de direitos autorais).',
    'You must not transmit any worms or viruses or any code of a destructive nature. Violation of any of the Terms will result in the immediate termination of your Services.': 'Você não deve transmitir worms ou vírus ou qualquer código de natureza destrutiva.A violação de qualquer um dos Termos resultará na rescisão imediata de seus Serviços.',
    'SECTION 2 – GENERAL CONDITIONS': 'SEÇÃO 2 – CONDIÇÕES GERAIS',
    'We reserve the right to refuse service to anyone for any reason at any time. You understand that your content (excluding credit card information) may be transferred unencrypted and involve (a) transmissions over various networks; and (b) changes to conform and adapt to technical requirements of connecting networks or devices. Credit card information is always encrypted during transfer over networks.': 'Nós temos total direito e autonomia para recusar qualquer um dos nossos serviços, a qualquer pessoa ou por qualquer motivo, e também a qualquer momento. Você entende que seu conteúdo (não incluindo informações de cartão de crédito) pode ser transferido sem criptografia e envolver (a) transmissões em várias redes; e (b) alterações para conformidade e adaptação aos requisitos técnicos de conexão de redes ou dispositivos. As informações do cartão de crédito são sempre criptografadas durante a transferência pelas redes.',
    'You agree not to reproduce, duplicate, copy, sell, resell, or exploit any part of the Service, use of the Service, or access to the Service or any contact on the site/application through which the service is provided, without express written permission from us.': 'Você concorda em não reproduzir, duplicar, copiar, vender, revender ou explorar qualquer parte do Serviço, uso do Serviço ou acesso ao Serviço ou qualquer contato no site / aplicativo através do qual o serviço é fornecido, sem permissão expressa por escrito por nós.',
    'The headings used in this agreement are included for convenience only and will not limit or otherwise affect these Terms.': 'Os títulos usados neste contrato são incluídos apenas para conveniência e não irão limitar ou afetar estes Termos.',
    'SECTION 3 – ACCURACY AND COMPLETENESS OF INFORMATION': 'SEÇÃO 3 – INFORMAÇÕES E INTEGRIDADE',
    'We are not responsible if the information provided here is not accurate, complete, or current. All material provided is for general information purposes only and should not be relied upon for making decisions without consulting primary information sources. Any reliance on the content provided is at your own risk.': 'Nós não somos responsáveis se o fornecimento das informações aqui não forem reais, completas ou atualizadas. Todo material fornecido é de informação geral, portanto não deve ser tomado em conta para tomar decisões sem consultar fontes de informações primárias, checando sua coerência, completude e colaboração em qualquer caso. Toda e qualquer confiança no conteúdo aqui exposto é por sua própria conta.',
    'This site may contain historical information, which is provided for your reference. We reserve the right to modify any document or information on this application/site at any time, without obligation to update any information on this page, and you agree that it is your responsibility to monitor any changes.': 'Este site mantém informações históricas, no qualquer normalmente é feira para sua referência. Reservamos o direito de alterar qualquer documento ou informação exposta neste aplicativo/site, mesmo sabendo que não temos nenhuma obrigatoriedade em atualizar qualquer informação nesta página, e você concorda que é sua responsabilidade monitorar qualquer alteração aqui realizada.',
    'SECTION 4 – MODIFICATIONS TO PRICES AND SERVICES': 'SEÇÃO 4 - MODIFICAÇÕES EM PREÇOS OU SERVIÇO',
    'We reserve the right to change the prices of our products without notice at any time or to discontinue the service or any part of it without notice at any time. We shall not be liable to you or any third party for any modification, price change, or discontinuation of the service.': 'Reservamos o nosso direito de alterar sem aviso prévio os preços de nossos produtos, a qualquer momento ou inclusive deixar de oferecer o serviço ou parte dele, sem nenhum aviso prévio, em qualquer tempo. Nos isentamos da responsabilidade perante você ou terceiros para toda e qualquer modificação, alteração de preço, ou inexistencia da prestação do serviço.',
    'SECTION 5 – PRODUCTS OR SERVICES (if applicable)': 'SEÇÃO 5 - PRODUTOS OU SERVIÇOS (quando aplicável)',
    'Certain products or services may be available exclusively through the application/site. We also reserve the right to limit quantities and apply return and exchange policies in accordance with our policy.': 'Determinados produtos ou serviços podem estar disponíveis exclusivamente por um meio do aplicativo/site, portanto também nos reservamos o direito de aplicar quantidades limitadas e também políticas de devolução e troca conforme a nossa política.',
    'We strive to display products as accurately as possible in terms of sizes and colors, but we cannot guarantee that the display of any color on your computer monitor will be accurate. We reserve the right to limit our products to any person, geographic region, or jurisdiction. We do not warrant that the quality of any products, services, information, or other materials purchased by you will meet your expectations, or that any errors in the service will be corrected.': 'Trabalhamos para tornar visível apenas produtos que tenham a maior precisão possível nos tamanhos e cores, porém não podemos garantir que a exibição de qualquer cor específica devido ao monitor do computador que o usuário utiliza. Reservamos o direito de limitar nossos produtos para qualquer pessoa, em qualquer local e também jurisdição. Também não garantimos a qualidade de qualquer produto disponível, e serviços, informações ou outro material adquirido por você venha atender suas expectativas, ou eventuais erros que podem existir na prestação do serviço.',
    'SECTION 6 – BILLING AND ACCOUNT INFORMATION': 'SEÇÃO 6 - FATURAMENTO E INFORMAÇÕES DE CONTA',
    'We reserve the right to refuse any order you place with us. We may, at our sole discretion, limit or cancel quantities purchased per person, per household, or per order. These restrictions may include orders placed by or under the same customer account, the same credit card, and/or orders that use the same billing and/or shipping address. In the event we make a change to or cancel an order, we may attempt to notify you by contacting the email and/or billing address/phone number provided at the time the order was made. We reserve the right to limit or prohibit orders that, in our sole judgment, appear to be placed by dealers, resellers, or distributors.': 'Nós nos reservamos o direito de recusar qualquer pedido que você fizer conosco. Podemos, a nosso exclusivo critério, limitar ou cancelar as quantidades compradas por pessoa, por família ou por pedido. Essas restrições podem incluir pedidos feitos por ou sob a mesma conta do cliente, o mesmo cartão de crédito e / ou pedidos que usam o mesmo faturamento e / ou endereço de entrega. No caso de fazermos uma alteração ou cancelar um pedido, podemos tentar notificá-lo entrando em contato com o e-mail e / ou endereço de cobrança / número de telefone fornecido no momento em que o pedido foi feito. Nós nos reservamos o direito de limitar ou proibir pedidos que, em nosso julgamento exclusivo, pareçam ser feitos por revendedores, revendedores ou distribuidores.',
    'You agree to provide current, complete, and accurate purchase and account information for all purchases made at our store. You agree to promptly update your account and other information, including your email address and credit card numbers and expiration dates, so that we can complete your transactions and contact you as needed. For more details, please review our Return Policy.': 'Você concorda em fornecer informações de conta e compra atuais, completas e precisas para todas as compras feitas em nossa loja. Você concorda em atualizar imediatamente sua conta e outras informações, incluindo seu endereço de e-mail e números de cartão de crédito e datas de vencimento, para que possamos concluir suas transações e entrar em contato com você conforme necessário.Para obter mais detalhes, consulte nossa Política de Devolução',
    'SECTION 7 – OPTIONAL TOOLS': 'SEÇÃO 7 - FERRAMENTAS OPCIONAIS',
    'We may provide you with access to third-party tools over which we neither monitor nor have any control or input. You acknowledge and agree that we provide access to such tools "as is" and "as available" without any warranties, representations, or conditions of any kind and without any endorsement. Any use by you of optional tools offered through the site/application is entirely at your own risk and discretion, and you should ensure that you are familiar with and approve the terms on which tools are provided by the relevant third-party provider. We may also, in the future, offer new services and/or features through the site/application (including the release of new tools and resources). Such new features and/or services shall also be subject to these TERMS AND CONDITIONS.': 'Existe a possibilidade de fornecermos ferramentas de terceiros, e neste caso não temos autonomia para monitorar ou ter qualquer controle e acesso. Você está ciente e concorda que fornecemos essas ferramentas, como são disponibilizadas, em seu estado atual, e informações oferecidas, sendo sem quaisquer garantias, representações ou condições de qualquer tipo, em qualquer endosso. Qualquer ferramenta extra disponibilizada em nosso aplicativo/site é de inteira responsabilidade sua e você deve se certificar e aprovar os termos fornecidos por ela. Também ressaltamos que podemos oferecer outros serviços ou novos recursos, e todos estarão sujeitos a estes TERMOS E CONDIÇÕES.',
    'SECTION 8 – PERSONAL INFORMATION': 'SEÇÃO 8 - INFORMAÇÕES PESSOAIS',
    'Your submission of personal information is governed by our Privacy Policy, following all applicable laws and regulations.': 'O envio de informações pessoais está contemplado em nossa Política de Privacidade, seguindo todas as normais e legislações vigentes.',
    'SECTION 9 – DISCLAIMER OF WARRANTIES; LIMITATION OF LIABILITY': 'SEÇÃO 9 - ISENÇÃO DE GARANTIAS; LIMITAÇÃO DE RESPONSABILIDADE',
    'We do not guarantee, represent, or warrant that your use of our service will be uninterrupted, timely, secure, or error-free.': 'Não garantimos, representamos ou garantimos que o uso de nosso serviço será ininterrupto, oportuno, seguro ou livre de erros.',
    'We do not warrant that the results that may be obtained from the use of the service will be accurate or reliable.': 'Não garantimos que os resultados que podem ser obtidos com o uso do serviço sejam precisos.',
    'You agree that from time to time we may remove the service for indefinite periods or cancel the service at any time, without notice to you.': 'Você concorda que, de tempos em tempos, podemos remover o serviço por períodos indefinidos ou cancelar o serviço a qualquer momento, sem aviso prévio.',
    "You expressly agree that your use of, or inability to use, the service is at your sole risk. The service and all products and services delivered to you through the service are (except as expressly stated by us) provided 'as is' and 'as available' for your use, without any representation, warranties, or conditions of any kind, either express or implied, including all implied warranties or conditions of merchantability, merchantable quality, fitness for a particular purpose, durability, title, and non-infringement.": 'Você concorda expressamente que o uso ou a incapacidade de usar o serviço é por sua conta e risco. O serviço e todos os produtos e serviços fornecidos a você por meio do serviço são (exceto conforme expressamente declarado por nós) fornecidos "como estão" e "conforme disponíveis" para seu uso, sem qualquer representação, garantias ou condições de qualquer tipo, expressas ou implícito, incluindo todas as garantias implícitas ou condições de comercialização, qualidade comercializável, adequação a uma finalidade específica, durabilidade, título e não violação.',
    'In no case shall we, our directors, officers, employees, affiliates, agents, contractors, interns, suppliers, service providers, or licensors be liable for any injury, loss, claim, or any direct, indirect, incidental, punitive, special, or consequential damages of any kind, including, without limitation lost profits, lost revenue, lost savings, loss of data, replacement costs, or any similar damages, whether based in contract, tort (including negligence), strict liability or otherwise, arising from your use of any of the service or any products procured using the service, or for any other claim related in any way to your use of the service or any product, including, but not limited to, any errors or omissions in any content, or any loss or damage of any kind incurred as a result of the use of the service or any content (or product) posted, transmitted, or otherwise made available via the service, even if advised of their possibility. Because some states or jurisdictions do not allow the exclusion or limitation of liability for consequential or incidental damages, in such states or jurisdictions, our liability shall be limited to the maximum extent permitted by law.': 'Em nenhum caso nós, nossos diretores, executivos, funcionários, afiliados, agentes, contratados, estagiários, fornecedores, prestadores de serviços ou licenciados seremos responsáveis ​​por qualquer lesão, perda, reclamação ou qualquer ação direta, indireta, incidental, punitiva, especial ou danos consequenciais de qualquer tipo, incluindo, sem limitação, lucros cessantes, receitas perdidas, economias perdidas, perda de dados, custos de substituição ou quaisquer danos semelhantes, seja com base em contrato, ato ilícito (incluindo negligência), responsabilidade objetiva ou de outra forma, decorrentes de seu uso de qualquer um dos serviços ou produtos adquiridos usando o serviço, ou para qualquer outra reclamação relacionada de qualquer forma ao seu uso do serviço ou de qualquer produto, incluindo, mas não se limitando a, quaisquer erros ou omissões em qualquer conteúdo, ou qualquer perda ou dano de qualquer tipo incorrido como resultado do uso do serviço ou de qualquer conteúdo (ou produto) postado, transmitido ou de outra forma disponibilizado por meio do serviço, mesmo se informado da possibilidade. Como alguns estados ou jurisdições não permitem a exclusão ou limitação de responsabilidade por danos conseqüentes ou incidentais, em tais estados ou jurisdições, nossa responsabilidade deve ser limitada à extensão máxima permitida por lei.',
    'SECTION 10 – TERMINATION OF SERVICE': 'SEÇÃO 10 – RESCISÃO DE SERVIÇO',
    'You may terminate this agreement at any time by notifying us that you no longer wish to use our services or when you cease using our site/application. Both parties may terminate this agreement at any time, and any charges or other information and pending procedures will be handled directly by the contract termination department.': 'Você poderá em qualquer momento rescindir este contrato, notificando que não deseja mais usar os nossos serviços ou quando deixar de utilizar nosso aplicativo/site. Ambas as partes poderão em qualquer ocasião rescindir este contrato a qualquer momento, e havendo encargos ou qualquer outra informação e procedimento pendente será tratado diretamente pelo departamento de rescisão de contratos.',
    'SECTION 11 – CUSTOMER SERVICE': 'SEÇÃO 11 – SERVIÇO DE ATENDIMENTO AO CLIENTE',
    'You will always have access to our customer service, whether by email, online chat on our site/application, or via our WhatsApp number. It is your responsibility to contact us whenever you have any questions or situations that may compromise your data or the processing of your information on our site/application. Response times vary depending on the inquiry sent, between 48 to 72 business hours.': 'Você sempre terá a sua disposição nosso serviço de atendimento ao cliente seja por e-mail, por chat online em nosso aplicativo/site, como também nossos atendimentos por número de WhatsApp, ficando na sua responsabilidade entrar em contato sempre que surgir qualquer dúvida ou situação que possa comprometer seus dados ou processamento da sua informação em nosso aplicativo/site. O tempo de resposta varia conforme a dúvida enviada, entre 48 a 72 horas úteis.',
    'SECTION 12 – SHIPPING': 'SEÇÃO 12 – ENVIOS',
    'Logistics and shipment policies are covered in our Shipping Policy, following all applicable laws and regulations.': 'A logística e envio de remessas está contemplado em nossa Política de Envio, seguindo todas as normais e legislações vigentes.',
    'SECTION 13 – GOVERNING LAW': 'SEÇÃO 13 - LEI APLICÁVEL',
    'These TERMS AND CONDITIONS and any separate agreements whereby we provide you Services shall be governed by and construed in accordance with the laws of Hong Kong.': 'Estes TERMOS E CONDIÇÕES e quaisquer acordos separados pelos quais fornecemos os Serviços a você serão regidos e interpretados de acordo com as leis de Hong Kong.',
    'SECTION 14 – CHANGES TO TERMS AND CONDITIONS': 'SEÇÃO 14 - ALTERAÇÕES NOS TERMOS E CONDIÇÕES',
    'You can review the most current version of the TERMS AND CONDITIONS OF USE at any time on this page. We reserve the right to update, change, or replace any part of': 'Em qualquer momento poderá acessar nesta página a versão mais atual dos TERMOS E CONDIÇÕES DE USO. Temos e reservamos o exclusivo direito em modificar qualquer parte dos TERMOS E CONDIÇÕES publicando suas atualizações em nosso aplicativo/site. Lembrando que é da sua responsabilidade checar com frequência se existem modificações vigentes. Seu uso ou acesso ao nosso aplicativo/site após qualquer alteração comprova que você está de acordo com nossos TERMOS E CONDIÇÕES DE USO e suas alterações realizadas.',

    "Thank you for your interest in Comexbcn.": "Agradecemos seu interesse na Comexbcn.",
    "Our commitment is to deliver quality service with transparency and efficiency, offering various shipping options worldwide. We have a decade of experience in this field, with hundreds of satisfied customers.": "Nosso compromisso é entregar um serviço de qualidade, com transparência e eficiência, entregando várias opções de remessa em diversos lugares do mundo. Possuímos experiência de uma década nesta atividade, com centenas de clientes satisfeitos.",
    "Below are the terms and conditions of our shipping policy.": "Abaixo detalhamos nossas condições e termos da nossa política de envio.",
    "1. Processing and Shipping Time": "1 Processamento e tempo de envio",
    "Processing time is typically between 2 to 4 days after payment confirmation. During this period, we will prepare your order.": "O tempo de processamento normalmente é entre 2 a 4 dias após a confirmação do seu pagamento. Neste momento iremos preparar o seu pedido.",
    "If there are any irregularities, we will contact you.": "Caso exista qualquer irregularidade entraremos em contato.",
    "2.1 International Shipping": "2.1 Envio Internacional",
    "Comexbcn offers international shipping. For any questions, please contact us through [our website](https://www.comexbcn.com).": "A Comexbcn realiza remessas internacionais, para qualquer dúvida a respeito entre em contato conosco. https://www.comexbcn.com",
    "Delivery Estimates and Applicable Fees": "Estimativas de entrega e taxas aplicadas",
    "We understand the importance of knowing the best market practices to minimize costs without compromising service quality. Comexbcn operates with transparency, providing realistic deadlines to avoid surprises during the process. Before finalizing your order, all timelines and costs will be available for your review. The delivery period starts from the moment the shipment is dispatched, not the order date. It's important to note that delivery estimates are not guaranteed. We do our best to meet your order requirements, but unexpected situations such as weather changes, attacks, force majeure, and other external events can delay delivery.": "Sabemos que neste mercado é necessário conhecer as melhores práticas do mercado, buscando diminuir os custos sem perder a qualidade na oferta do serviço, neste caso a Comebcn trabalha com transparência, entregando prazos reais para que não existam surpresas durante o processo. Antes de finalizar seu pedido todos os prazos estarão disponíveis para conhecimento, assim como os custos praticados. O prazo de entrega inicia a partir do momento do envio da remessa, não na data em que o pedido foi efetivado. Importante ressaltar que as estimativas de chegada não são garantidas. Também que nosso compromisso é fazer o máximo que podemos para atender seu pedido, porém situações inesperadas podem atrasar a entrega, como por exemplo: mudanças climáticas, atentados, atividades de força maior, entre outras situações externas que impactam a logística direta ou indiretamente impossibilitando a entrega da remessa.",
    "3.1 Delivery Observations": "3.1 Observação sobre nossa entrega",
    "a. The delivery date may vary depending on the carrier, delivery method, location, and items ordered.": "a. data para a entrega pode ser variar conforme a transportadora, o método de entrega, local e inclusive os itens solicitados.",
    "b. Separate Product Deliveries": "b.Os produtos podem ser entregues separadamente",
    "Products may be delivered separately. When placing your order, please consider these factors for the estimated delivery date.": "Quando você realiza seu pedido importante considerar esses fatores para a data de entrega estimulada.",
    "Transit Time:The time it takes for your shipment to move from our distribution center to the local carrier.": "Tempo de trânsito:tempo para que a sua remessa saia do nosso centro de distribuição até a transportadora local.",
    "Shipment Weight:Shipping costs are based on the weight of your package and the chosen delivery method.": "Pesagem Remessa: Os valores aplicados no custo de envio são conforme o peso da sua encomenda e a forma de entrega estipulada.",
    "The final cost of your order can be seen after proceeding to the final checkout screen. Shipping costs will be displayed when you finalize your order.": "O valor final do seu pedido pode ser visto após prosseguir na tela final da sua compra. Quando for finalizar seu pedido aparecerá os custos de envio.",
    "Tracking": "Rastreamento",
    "As previously mentioned, Comexbcn operates transparently and always opts for tracked shipping to ensure peace of mind throughout the process. After completing a purchase with us, you will have access to tracking your order.": "A Comecbcn como já mencionamos anteriormente trabalha de forma transparente, e sempre opta por envio com rastreamento, para que assim todos tenham maior tranquilidade no processo. Assim que finalizar um pedido de compra conosco terá a sua disposição o rastreo do seu pedido.",
    "Damages": "Danificações",
    "If you notice any damage upon delivery, please contact us promptly through our WhatsApp support or via our [website](https://www.comexbcn.com).": "Se perceber qualquer dano na entrega do pedido, por gentileza entre em contato conosco rapidamente em nosso atendimento por WhatsApp ou em",
    "Lost Package": "Pacote Perdido",
    "While rare, if a package is lost, please check possible locations where the delivery person might have left it, including with neighbors. Before contacting us, we kindly ask you to check all possible locations to avoid unnecessary steps. If you still cannot locate the package, contact us via [our website](https://www.comexbcn.com) to report the lost package.": "São situações raras, porém se for a situação, verifique os possíveis lugares onde os entregadores deixam os pacotes, inclusive com o vizinho. Antes que entre em contato conosco solicitamos gentilmente que cheque todas as possiblidades para não termos retrabalhos. Se mesmo assim não localizou, entre em contato conosco em https://www.comexbcn.com para informar pacotes perdidos.",
    "Miscellaneous Questions": "Questões diversas",
    "For any questions not mentioned here, please do not hesitate to contact us. We also have a FAQ page that may be useful for your situation. Visit our website: [www.comexbcn.com](https://www.comexbcn.com).": "Qualquer dúvida referente a questões não mencionadas aqui, por gentileza não dúvide em entrar em contato conosco. Temos também uma página de dúvidas frequentes que talvez seja útil na sua situação. Acesse o nosso site: www.comexbcn.com",

    "正在处理中，请勿重复操作": "Processando em andamento, por favor, evite ações duplicadas.",

    "Please select type first.": "Selecione o tipo primeiro.",
    "After-sales Service": "Serviço pós-venda",
    "Deal Type": "Tipo de negócio",
    "Deliver Time": "Tempo de entrega",
    "Real Paid": "Realmente pago",
    "SKU": "SKU",
    "待审批":"Pendente",
    "已审批":"Aprovado",
    "tradeAmount":"Valor da Transação",
    "itemAmount":"Valor dos Itens",
    "discountAmount":"Valor do Desconto",
    "refundAmount":"Valor do Reembolso",
    "Oops, no data found! Try a different search or check back later.": "Oops, nenhum dado encontrado! Tente uma busca diferente ou volte mais tarde.",

    "Item Amount": "Valor do Item",
    "Discount Amount": "Valor do Desconto",
    "CreatedAt": "Pago em",
    "PaidAt": "Compra em",
    "DeliverAt": "Entregue em",
    "Contact Information": "Informações de Contato",
    "Zipcode": "CEP",
    "Phone number": "Número",
    "E-mail": "E-mail",
    "Track Company": "Empresa de Rastreamento",
    "Notes": "Anotações",
    "Apartment, sulte": "Apartamento, suíte",
    "Name": "Nome",
    "Time": "Tempo",

    "Re-quote": "Re-citação",
    "Restore": "Restaurar",
}